import { MONGO_COLLECTIONS } from '../../../consts'

export const ALL = 'ALL'
export const EMPTY = 'empty'
export const MISSING = 'missing'
export const UNASSIGNED_PANELS_TAB = {
  name: MISSING,
  title: 'unassigned_panels_tab',
  position: MISSING,
  panelClass: EMPTY,
}
export const COLUMN_POSITIONS = [EMPTY, 'top', 'middle', 'left', 'right', 'bottom']
export const EMPTY_LAYOUT_TEMPLATE = {
  gridItems: [],
  gridLayout: {
    colNum: 12,
    margin: 10,
    autoSize: true,
  },
  idSubsystem: 10,
  system: 26,
  gridLayoutName: 'empty',
  tabProperties: {
    tabPosition: 'top',
    type: 'card',
    stretch: true,
  },
  tabs: {
    empty: [
      {
        name: 'tab-1',
        title: 'Default',
        position: 'empty',
      },
    ],
  },
}
import { cloneDeep, get, merge, pickBy, set } from 'lodash'
import jQuery from 'jquery'

import qtip2 from 'qtip2'

void qtip2

/**
 * @class helpers
 *
 * @description This component contains functions commonly used by the LayoutDesigner
 */
export const prepareSave = (layout, url, gridLayoutName = '', columns = {}, tabProperties = {}) => {
  let tabs = cloneDeep(columns)
  if (tabs.missing) {
    tabs.missing = tabs.missing.filter((tab) => tab.position === UNASSIGNED_PANELS_TAB.position)
  }
  tabs = pickBy(tabs, (column) => column.length)
  const gridItems = []
  const clone = cloneDeep(layout)
  clone.forEach((e) => {
    if (e.params && e.params.dictionary) {
      Object.keys(e.params.dictionary).forEach((key) => {
        if (key.includes('.')) {
          const value = e.params.dictionary[key]
          const newkey = key.replace(/\./g, '#')
          delete e.params.dictionary[key]
          e.params.dictionary[newkey] = value
        }
      })
    }
    const item = {
      type: e.type,
      params: e.params,
      height: e.height,
      columnId: e.columnId || EMPTY,
      tabId: e.tabId,
      position: {
        i: e.i,
        h: e.h,
        w: e.w,
        x: e.x,
        y: e.y,
      },
      panel: {
        title: e.title,
        panelClass: e.panelClass,
        icon: e.icon,
        collapse: e.collapse,
        fixHeight: e.fixHeight,
        footer: e.footer,
      },
    }
    gridItems.push(item)
  })
  return {
    url,
    gridLayout: {
      colNum: 12,
      margin: 10,
      autoSize: true,
    },
    gridLayoutName,
    gridItems,
    tabs,
    tabProperties,
  }
}

export const fetch = (data) => {
  return data.gridItems.map((item) => {
    if (item.params && item.params.dictionary) {
      Object.keys(item.params.dictionary).forEach((key) => {
        if (key.includes('#')) {
          const value = item.params.dictionary[key]
          const newkey = key.replace(/#/g, '.')
          delete item.params.dictionary[key]
          item.params.dictionary[newkey] = value
        }
      })
    }
    return {
      type: item.type,
      height: item.height,
      ...item.panel,
      params: item.params,
      ...item.position,
      columnId: item.columnId || UNASSIGNED_PANELS_TAB.position,
      tabTitle: item.tabTitle || UNASSIGNED_PANELS_TAB.title,
      tabId: item.tabId || UNASSIGNED_PANELS_TAB.name,
    }
  })
}

export const materialIcons = () => [
  { label: 'Abc', key: 'abc' },
  { label: 'AcUnit', key: 'ac_unit' },
  {
    label: 'AccessAlarm',
    key: 'access_alarm',
  },
  { label: 'AccessAlarms', key: 'access_alarms' },
  {
    label: 'AccessTime',
    key: 'access_time',
  },
  { label: 'AccessTimeFilled', key: 'access_time_filled' },
  {
    label: 'Accessibility',
    key: 'accessibility',
  },
  { label: 'AccessibilityNew', key: 'accessibility_new' },
  {
    label: 'Accessible',
    key: 'accessible',
  },
  { label: 'AccessibleForward', key: 'accessible_forward' },
  {
    label: 'AccountBalance',
    key: 'account_balance',
  },
  { label: 'AccountBalanceWallet', key: 'account_balance_wallet' },
  {
    label: 'AccountBox',
    key: 'account_box',
  },
  { label: 'AccountCircle', key: 'account_circle' },
  {
    label: 'AccountTree',
    key: 'account_tree',
  },
  { label: 'AdUnits', key: 'ad_units' },
  { label: 'Adb', key: 'adb' },
  {
    label: 'Add',
    key: 'add',
  },
  { label: 'AddAPhoto', key: 'add_a_photo' },
  { label: 'AddAlarm', key: 'add_alarm' },
  {
    label: 'AddAlert',
    key: 'add_alert',
  },
  { label: 'AddBox', key: 'add_box' },
  { label: 'AddBusiness', key: 'add_business' },
  {
    label: 'AddCard',
    key: 'add_card',
  },
  { label: 'AddCircle', key: 'add_circle' },
  {
    label: 'AddCircleOutline',
    key: 'add_circle_outline',
  },
  { label: 'AddComment', key: 'add_comment' },
  {
    label: 'AddHome',
    key: 'add_home',
  },
  { label: 'AddHomeWork', key: 'add_home_work' },
  {
    label: 'AddIcCall',
    key: 'add_ic_call',
  },
  { label: 'AddLink', key: 'add_link' },
  {
    label: 'AddLocation',
    key: 'add_location',
  },
  { label: 'AddLocationAlt', key: 'add_location_alt' },
  {
    label: 'AddModerator',
    key: 'add_moderator',
  },
  { label: 'AddPhotoAlternate', key: 'add_photo_alternate' },
  {
    label: 'AddReaction',
    key: 'add_reaction',
  },
  { label: 'AddRoad', key: 'add_road' },
  {
    label: 'AddShoppingCart',
    key: 'add_shopping_cart',
  },
  { label: 'AddTask', key: 'add_task' },
  {
    label: 'AddToDrive',
    key: 'add_to_drive',
  },
  { label: 'AddToHomeScreen', key: 'add_to_home_screen' },
  {
    label: 'AddToPhotos',
    key: 'add_to_photos',
  },
  { label: 'AddToQueue', key: 'add_to_queue' },
  {
    label: 'Addchart',
    key: 'addchart',
  },
  { label: 'AdfScanner', key: 'adf_scanner' },
  {
    label: 'Adjust',
    key: 'adjust',
  },
  { label: 'AdminPanelSettings', key: 'admin_panel_settings' },
  {
    label: 'Agriculture',
    key: 'agriculture',
  },
  { label: 'Air', key: 'air' },
  {
    label: 'AirlineSeatFlat',
    key: 'airline_seat_flat',
  },
  { label: 'AirlineSeatFlatAngled', key: 'airline_seat_flat_angled' },
  {
    label: 'AirlineSeatIndividualSuite',
    key: 'airline_seat_individual_suite',
  },
  { label: 'AirlineSeatLegroomExtra', key: 'airline_seat_legroom_extra' },
  {
    label: 'AirlineSeatLegroomNormal',
    key: 'airline_seat_legroom_normal',
  },
  {
    label: 'AirlineSeatLegroomReduced',
    key: 'airline_seat_legroom_reduced',
  },
  { label: 'AirlineSeatReclineExtra', key: 'airline_seat_recline_extra' },
  {
    label: 'AirlineSeatReclineNormal',
    key: 'airline_seat_recline_normal',
  },
  { label: 'AirlineStops', key: 'airline_stops' },
  {
    label: 'Airlines',
    key: 'airlines',
  },
  { label: 'AirplaneTicket', key: 'airplane_ticket' },
  {
    label: 'AirplanemodeActive',
    key: 'airplanemode_active',
  },
  { label: 'AirplanemodeInactive', key: 'airplanemode_inactive' },
  {
    label: 'Airplay',
    key: 'airplay',
  },
  { label: 'AirportShuttle', key: 'airport_shuttle' },
  {
    label: 'Alarm',
    key: 'alarm',
  },
  { label: 'AlarmAdd', key: 'alarm_add' },
  { label: 'AlarmOff', key: 'alarm_off' },
  {
    label: 'AlarmOn',
    key: 'alarm_on',
  },
  { label: 'Album', key: 'album' },
  {
    label: 'AlignHorizontalCenter',
    key: 'align_horizontal_center',
  },
  { label: 'AlignHorizontalLeft', key: 'align_horizontal_left' },
  {
    label: 'AlignHorizontalRight',
    key: 'align_horizontal_right',
  },
  { label: 'AlignVerticalBottom', key: 'align_vertical_bottom' },
  {
    label: 'AlignVerticalCenter',
    key: 'align_vertical_center',
  },
  { label: 'AlignVerticalTop', key: 'align_vertical_top' },
  {
    label: 'AllInbox',
    key: 'all_inbox',
  },
  { label: 'AllInclusive', key: 'all_inclusive' },
  {
    label: 'AllOut',
    key: 'all_out',
  },
  { label: 'AltRoute', key: 'alt_route' },
  {
    label: 'AlternateEmail',
    key: 'alternate_email',
  },
  { label: 'Analytics', key: 'analytics' },
  { label: 'Anchor', key: 'anchor' },
  {
    label: 'Android',
    key: 'android',
  },
  { label: 'Animation', key: 'animation' },
  { label: 'Announcement', key: 'announcement' },
  {
    label: 'Aod',
    key: 'aod',
  },
  { label: 'Apartment', key: 'apartment' },
  { label: 'Api', key: 'api' },
  {
    label: 'AppBlocking',
    key: 'app_blocking',
  },
  { label: 'AppRegistration', key: 'app_registration' },
  {
    label: 'AppSettingsAlt',
    key: 'app_settings_alt',
  },
  { label: 'AppShortcut', key: 'app_shortcut' },
  { label: 'Apple', key: 'apple' },
  {
    label: 'Approval',
    key: 'approval',
  },
  { label: 'Apps', key: 'apps' },
  { label: 'AppsOutage', key: 'apps_outage' },
  {
    label: 'Architecture',
    key: 'architecture',
  },
  { label: 'Archive', key: 'archive' },
  { label: 'ArrowBack', key: 'arrow_back' },
  {
    label: 'ArrowBackIos',
    key: 'arrow_back_ios',
  },
  { label: 'ArrowBackIosNew', key: 'arrow_back_ios_new' },
  {
    label: 'ArrowCircleDown',
    key: 'arrow_circle_down',
  },
  { label: 'ArrowCircleLeft', key: 'arrow_circle_left' },
  {
    label: 'ArrowCircleRight',
    key: 'arrow_circle_right',
  },
  { label: 'ArrowCircleUp', key: 'arrow_circle_up' },
  {
    label: 'ArrowDownward',
    key: 'arrow_downward',
  },
  { label: 'ArrowDropDown', key: 'arrow_drop_down' },
  {
    label: 'ArrowDropDownCircle',
    key: 'arrow_drop_down_circle',
  },
  { label: 'ArrowDropUp', key: 'arrow_drop_up' },
  {
    label: 'ArrowForward',
    key: 'arrow_forward',
  },
  { label: 'ArrowForwardIos', key: 'arrow_forward_ios' },
  {
    label: 'ArrowLeft',
    key: 'arrow_left',
  },
  { label: 'ArrowOutward', key: 'arrow_outward' },
  {
    label: 'ArrowRight',
    key: 'arrow_right',
  },
  { label: 'ArrowRightAlt', key: 'arrow_right_alt' },
  {
    label: 'ArrowUpward',
    key: 'arrow_upward',
  },
  { label: 'ArtTrack', key: 'art_track' },
  { label: 'Article', key: 'article' },
  {
    label: 'AspectRatio',
    key: 'aspect_ratio',
  },
  { label: 'Assessment', key: 'assessment' },
  {
    label: 'Assignment',
    key: 'assignment',
  },
  { label: 'AssignmentInd', key: 'assignment_ind' },
  {
    label: 'AssignmentLate',
    key: 'assignment_late',
  },
  { label: 'AssignmentReturn', key: 'assignment_return' },
  {
    label: 'AssignmentReturned',
    key: 'assignment_returned',
  },
  { label: 'AssignmentTurnedIn', key: 'assignment_turned_in' },
  {
    label: 'AssistWalker',
    key: 'assist_walker',
  },
  { label: 'Assistant', key: 'assistant' },
  {
    label: 'AssistantDirection',
    key: 'assistant_direction',
  },
  { label: 'AssistantPhoto', key: 'assistant_photo' },
  {
    label: 'AssuredWorkload',
    key: 'assured_workload',
  },
  { label: 'Atm', key: 'atm' },
  { label: 'AttachEmail', key: 'attach_email' },
  {
    label: 'AttachFile',
    key: 'attach_file',
  },
  { label: 'AttachMoney', key: 'attach_money' },
  {
    label: 'Attachment',
    key: 'attachment',
  },
  { label: 'Attractions', key: 'attractions' },
  {
    label: 'Attribution',
    key: 'attribution',
  },
  { label: 'AudioFile', key: 'audio_file' },
  {
    label: 'Audiotrack',
    key: 'audiotrack',
  },
  { label: 'AutoAwesome', key: 'auto_awesome' },
  {
    label: 'AutoAwesomeMosaic',
    key: 'auto_awesome_mosaic',
  },
  { label: 'AutoAwesomeMotion', key: 'auto_awesome_motion' },
  {
    label: 'AutoDelete',
    key: 'auto_delete',
  },
  { label: 'AutoFixHigh', key: 'auto_fix_high' },
  {
    label: 'AutoFixNormal',
    key: 'auto_fix_normal',
  },
  { label: 'AutoFixOff', key: 'auto_fix_off' },
  {
    label: 'AutoGraph',
    key: 'auto_graph',
  },
  { label: 'AutoMode', key: 'auto_mode' },
  {
    label: 'AutoStories',
    key: 'auto_stories',
  },
  { label: 'AutofpsSelect', key: 'autofps_select' },
  {
    label: 'Autorenew',
    key: 'autorenew',
  },
  { label: 'AvTimer', key: 'av_timer' },
  {
    label: 'BabyChangingStation',
    key: 'baby_changing_station',
  },
  { label: 'Backpack', key: 'backpack' },
  { label: 'Backspace', key: 'backspace' },
  {
    label: 'Backup',
    key: 'backup',
  },
  { label: 'BackupTable', key: 'backup_table' },
  { label: 'Badge', key: 'badge' },
  {
    label: 'BakeryDining',
    key: 'bakery_dining',
  },
  { label: 'Balance', key: 'balance' },
  { label: 'Balcony', key: 'balcony' },
  {
    label: 'Ballot',
    key: 'ballot',
  },
  { label: 'BarChart', key: 'bar_chart' },
  {
    label: 'BatchPrediction',
    key: 'batch_prediction',
  },
  { label: 'Bathroom', key: 'bathroom' },
  { label: 'Bathtub', key: 'bathtub' },
  {
    label: 'Battery0Bar',
    key: 'battery_0_bar',
  },
  { label: 'Battery1Bar', key: 'battery_1_bar' },
  {
    label: 'Battery20',
    key: 'battery_20',
  },
  { label: 'Battery2Bar', key: 'battery_2_bar' },
  {
    label: 'Battery30',
    key: 'battery_30',
  },
  { label: 'Battery3Bar', key: 'battery_3_bar' },
  {
    label: 'Battery4Bar',
    key: 'battery_4_bar',
  },
  { label: 'Battery50', key: 'battery_50' },
  {
    label: 'Battery5Bar',
    key: 'battery_5_bar',
  },
  { label: 'Battery60', key: 'battery_60' },
  {
    label: 'Battery6Bar',
    key: 'battery_6_bar',
  },
  { label: 'Battery80', key: 'battery_80' },
  {
    label: 'Battery90',
    key: 'battery_90',
  },
  { label: 'BatteryAlert', key: 'battery_alert' },
  {
    label: 'BatteryCharging20',
    key: 'battery_charging_20',
  },
  { label: 'BatteryCharging30', key: 'battery_charging_30' },
  {
    label: 'BatteryCharging50',
    key: 'battery_charging_50',
  },
  { label: 'BatteryCharging60', key: 'battery_charging_60' },
  {
    label: 'BatteryCharging80',
    key: 'battery_charging_80',
  },
  { label: 'BatteryCharging90', key: 'battery_charging_90' },
  {
    label: 'BatteryChargingFull',
    key: 'battery_charging_full',
  },
  { label: 'BatteryFull', key: 'battery_full' },
  {
    label: 'BatterySaver',
    key: 'battery_saver',
  },
  { label: 'BatteryStd', key: 'battery_std' },
  {
    label: 'BatteryUnknown',
    key: 'battery_unknown',
  },
  { label: 'BeachAccess', key: 'beach_access' },
  { label: 'Bed', key: 'bed' },
  {
    label: 'BedroomBaby',
    key: 'bedroom_baby',
  },
  { label: 'BedroomChild', key: 'bedroom_child' },
  {
    label: 'BedroomParent',
    key: 'bedroom_parent',
  },
  { label: 'Bedtime', key: 'bedtime' },
  { label: 'BedtimeOff', key: 'bedtime_off' },
  {
    label: 'Beenhere',
    key: 'beenhere',
  },
  { label: 'Bento', key: 'bento' },
  { label: 'BikeScooter', key: 'bike_scooter' },
  {
    label: 'Biotech',
    key: 'biotech',
  },
  { label: 'Blender', key: 'blender' },
  { label: 'Blind', key: 'blind' },
  {
    label: 'Blinds',
    key: 'blinds',
  },
  { label: 'BlindsClosed', key: 'blinds_closed' },
  { label: 'Block', key: 'block' },
  {
    label: 'Bloodtype',
    key: 'bloodtype',
  },
  { label: 'Bluetooth', key: 'bluetooth' },
  {
    label: 'BluetoothAudio',
    key: 'bluetooth_audio',
  },
  { label: 'BluetoothConnected', key: 'bluetooth_connected' },
  {
    label: 'BluetoothDisabled',
    key: 'bluetooth_disabled',
  },
  { label: 'BluetoothDrive', key: 'bluetooth_drive' },
  {
    label: 'BluetoothSearching',
    key: 'bluetooth_searching',
  },
  { label: 'BlurCircular', key: 'blur_circular' },
  {
    label: 'BlurLinear',
    key: 'blur_linear',
  },
  { label: 'BlurOff', key: 'blur_off' },
  { label: 'BlurOn', key: 'blur_on' },
  {
    label: 'Bolt',
    key: 'bolt',
  },
  { label: 'Book', key: 'book' },
  { label: 'BookOnline', key: 'book_online' },
  {
    label: 'Bookmark',
    key: 'bookmark',
  },
  { label: 'BookmarkAdd', key: 'bookmark_add' },
  {
    label: 'BookmarkAdded',
    key: 'bookmark_added',
  },
  { label: 'BookmarkBorder', key: 'bookmark_border' },
  {
    label: 'BookmarkRemove',
    key: 'bookmark_remove',
  },
  { label: 'Bookmarks', key: 'bookmarks' },
  {
    label: 'BorderAll',
    key: 'border_all',
  },
  { label: 'BorderBottom', key: 'border_bottom' },
  {
    label: 'BorderClear',
    key: 'border_clear',
  },
  { label: 'BorderColor', key: 'border_color' },
  {
    label: 'BorderHorizontal',
    key: 'border_horizontal',
  },
  { label: 'BorderInner', key: 'border_inner' },
  {
    label: 'BorderLeft',
    key: 'border_left',
  },
  { label: 'BorderOuter', key: 'border_outer' },
  {
    label: 'BorderRight',
    key: 'border_right',
  },
  { label: 'BorderStyle', key: 'border_style' },
  {
    label: 'BorderTop',
    key: 'border_top',
  },
  { label: 'BorderVertical', key: 'border_vertical' },
  {
    label: 'Boy',
    key: 'boy',
  },
  { label: 'BrandingWatermark', key: 'branding_watermark' },
  {
    label: 'BreakfastDining',
    key: 'breakfast_dining',
  },
  { label: 'Brightness1', key: 'brightness_1' },
  {
    label: 'Brightness2',
    key: 'brightness_2',
  },
  { label: 'Brightness3', key: 'brightness_3' },
  {
    label: 'Brightness4',
    key: 'brightness_4',
  },
  { label: 'Brightness5', key: 'brightness_5' },
  {
    label: 'Brightness6',
    key: 'brightness_6',
  },
  { label: 'Brightness7', key: 'brightness_7' },
  {
    label: 'BrightnessAuto',
    key: 'brightness_auto',
  },
  { label: 'BrightnessHigh', key: 'brightness_high' },
  {
    label: 'BrightnessLow',
    key: 'brightness_low',
  },
  { label: 'BrightnessMedium', key: 'brightness_medium' },
  {
    label: 'BroadcastOnHome',
    key: 'broadcast_on_home',
  },
  { label: 'BroadcastOnPersonal', key: 'broadcast_on_personal' },
  {
    label: 'BrokenImage',
    key: 'broken_image',
  },
  { label: 'BrowseGallery', key: 'browse_gallery' },
  {
    label: 'BrowserNotSupported',
    key: 'browser_not_supported',
  },
  { label: 'BrowserUpdated', key: 'browser_updated' },
  {
    label: 'BrunchDining',
    key: 'brunch_dining',
  },
  { label: 'Brush', key: 'brush' },
  { label: 'BubbleChart', key: 'bubble_chart' },
  {
    label: 'BugReport',
    key: 'bug_report',
  },
  { label: 'Build', key: 'build' },
  { label: 'BuildCircle', key: 'build_circle' },
  {
    label: 'Bungalow',
    key: 'bungalow',
  },
  { label: 'BurstMode', key: 'burst_mode' },
  { label: 'BusAlert', key: 'bus_alert' },
  {
    label: 'Business',
    key: 'business',
  },
  { label: 'BusinessCenter', key: 'business_center' },
  { label: 'Cabin', key: 'cabin' },
  {
    label: 'Cable',
    key: 'cable',
  },
  { label: 'Cached', key: 'cached' },
  { label: 'Cake', key: 'cake' },
  {
    label: 'Calculate',
    key: 'calculate',
  },
  { label: 'CalendarMonth', key: 'calendar_month' },
  {
    label: 'CalendarToday',
    key: 'calendar_today',
  },
  { label: 'CalendarViewDay', key: 'calendar_view_day' },
  {
    label: 'CalendarViewMonth',
    key: 'calendar_view_month',
  },
  { label: 'CalendarViewWeek', key: 'calendar_view_week' },
  {
    label: 'Call',
    key: 'call',
  },
  { label: 'CallEnd', key: 'call_end' },
  { label: 'CallMade', key: 'call_made' },
  {
    label: 'CallMerge',
    key: 'call_merge',
  },
  { label: 'CallMissed', key: 'call_missed' },
  {
    label: 'CallMissedOutgoing',
    key: 'call_missed_outgoing',
  },
  { label: 'CallReceived', key: 'call_received' },
  {
    label: 'CallSplit',
    key: 'call_split',
  },
  { label: 'CallToAction', key: 'call_to_action' },
  {
    label: 'Camera',
    key: 'camera',
  },
  { label: 'CameraAlt', key: 'camera_alt' },
  {
    label: 'CameraEnhance',
    key: 'camera_enhance',
  },
  { label: 'CameraFront', key: 'camera_front' },
  {
    label: 'CameraIndoor',
    key: 'camera_indoor',
  },
  { label: 'CameraOutdoor', key: 'camera_outdoor' },
  {
    label: 'CameraRear',
    key: 'camera_rear',
  },
  { label: 'CameraRoll', key: 'camera_roll' },
  {
    label: 'Cameraswitch',
    key: 'cameraswitch',
  },
  { label: 'Campaign', key: 'campaign' },
  {
    label: 'Cancel',
    key: 'cancel',
  },
  { label: 'CancelPresentation', key: 'cancel_presentation' },
  {
    label: 'CancelScheduleSend',
    key: 'cancel_schedule_send',
  },
  { label: 'CandlestickChart', key: 'candlestick_chart' },
  {
    label: 'CarCrash',
    key: 'car_crash',
  },
  { label: 'CarRental', key: 'car_rental' },
  {
    label: 'CarRepair',
    key: 'car_repair',
  },
  { label: 'CardGiftcard', key: 'card_giftcard' },
  {
    label: 'CardMembership',
    key: 'card_membership',
  },
  { label: 'CardTravel', key: 'card_travel' },
  { label: 'Carpenter', key: 'carpenter' },
  {
    label: 'Cases',
    key: 'cases',
  },
  { label: 'Casino', key: 'casino' },
  { label: 'Cast', key: 'cast' },
  {
    label: 'CastConnected',
    key: 'cast_connected',
  },
  { label: 'CastForEducation', key: 'cast_for_education' },
  {
    label: 'Castle',
    key: 'castle',
  },
  { label: 'CatchingPokemon', key: 'catching_pokemon' },
  {
    label: 'Category',
    key: 'category',
  },
  { label: 'Celebration', key: 'celebration' },
  {
    label: 'CellTower',
    key: 'cell_tower',
  },
  { label: 'CellWifi', key: 'cell_wifi' },
  {
    label: 'CenterFocusStrong',
    key: 'center_focus_strong',
  },
  { label: 'CenterFocusWeak', key: 'center_focus_weak' },
  {
    label: 'Chair',
    key: 'chair',
  },
  { label: 'ChairAlt', key: 'chair_alt' },
  { label: 'Chalet', key: 'chalet' },
  {
    label: 'ChangeCircle',
    key: 'change_circle',
  },
  { label: 'ChangeHistory', key: 'change_history' },
  {
    label: 'ChargingStation',
    key: 'charging_station',
  },
  { label: 'Chat', key: 'chat' },
  {
    label: 'ChatBubble',
    key: 'chat_bubble',
  },
  { label: 'ChatBubbleOutline', key: 'chat_bubble_outline' },
  {
    label: 'Check',
    key: 'check',
  },
  { label: 'CheckBox', key: 'check_box' },
  {
    label: 'CheckBoxOutlineBlank',
    key: 'check_box_outline_blank',
  },
  { label: 'CheckCircle', key: 'check_circle' },
  {
    label: 'CheckCircleOutline',
    key: 'check_circle_outline',
  },
  { label: 'Checkroom', key: 'checkroom' },
  {
    label: 'ChevronLeft',
    key: 'chevron_left',
  },
  { label: 'ChevronRight', key: 'chevron_right' },
  {
    label: 'ChildCare',
    key: 'child_care',
  },
  { label: 'ChildFriendly', key: 'child_friendly' },
  {
    label: 'ChromeReaderMode',
    key: 'chrome_reader_mode',
  },
  { label: 'Church', key: 'church' },
  { label: 'Circle', key: 'circle' },
  {
    label: 'CircleNotifications',
    key: 'circle_notifications',
  },
  { label: 'Class', key: 'class' },
  {
    label: 'CleanHands',
    key: 'clean_hands',
  },
  { label: 'CleaningServices', key: 'cleaning_services' },
  {
    label: 'Clear',
    key: 'clear',
  },
  { label: 'ClearAll', key: 'clear_all' },
  { label: 'Close', key: 'close' },
  {
    label: 'CloseFullscreen',
    key: 'close_fullscreen',
  },
  { label: 'ClosedCaption', key: 'closed_caption' },
  {
    label: 'ClosedCaptionDisabled',
    key: 'closed_caption_disabled',
  },
  { label: 'ClosedCaptionOff', key: 'closed_caption_off' },
  {
    label: 'Cloud',
    key: 'cloud',
  },
  { label: 'CloudCircle', key: 'cloud_circle' },
  {
    label: 'CloudDone',
    key: 'cloud_done',
  },
  { label: 'CloudDownload', key: 'cloud_download' },
  {
    label: 'CloudOff',
    key: 'cloud_off',
  },
  { label: 'CloudQueue', key: 'cloud_queue' },
  {
    label: 'CloudSync',
    key: 'cloud_sync',
  },
  { label: 'CloudUpload', key: 'cloud_upload' },
  { label: 'Co2', key: 'co_2' },
  {
    label: 'CoPresent',
    key: 'co_present',
  },
  { label: 'Code', key: 'code' },
  { label: 'CodeOff', key: 'code_off' },
  {
    label: 'Coffee',
    key: 'coffee',
  },
  { label: 'CoffeeMaker', key: 'coffee_maker' },
  {
    label: 'Collections',
    key: 'collections',
  },
  { label: 'CollectionsBookmark', key: 'collections_bookmark' },
  {
    label: 'ColorLens',
    key: 'color_lens',
  },
  { label: 'Colorize', key: 'colorize' },
  { label: 'Comment', key: 'comment' },
  {
    label: 'CommentBank',
    key: 'comment_bank',
  },
  { label: 'CommentsDisabled', key: 'comments_disabled' },
  {
    label: 'Commit',
    key: 'commit',
  },
  { label: 'Commute', key: 'commute' },
  { label: 'Compare', key: 'compare' },
  {
    label: 'CompareArrows',
    key: 'compare_arrows',
  },
  { label: 'CompassCalibration', key: 'compass_calibration' },
  {
    label: 'Compress',
    key: 'compress',
  },
  { label: 'Computer', key: 'computer' },
  {
    label: 'ConfirmationNumber',
    key: 'confirmation_number',
  },
  { label: 'ConnectWithoutContact', key: 'connect_without_contact' },
  {
    label: 'ConnectedTv',
    key: 'connected_tv',
  },
  { label: 'ConnectingAirports', key: 'connecting_airports' },
  {
    label: 'Construction',
    key: 'construction',
  },
  { label: 'ContactEmergency', key: 'contact_emergency' },
  {
    label: 'ContactMail',
    key: 'contact_mail',
  },
  { label: 'ContactPage', key: 'contact_page' },
  {
    label: 'ContactPhone',
    key: 'contact_phone',
  },
  { label: 'ContactSupport', key: 'contact_support' },
  {
    label: 'Contactless',
    key: 'contactless',
  },
  { label: 'Contacts', key: 'contacts' },
  {
    label: 'ContentCopy',
    key: 'content_copy',
  },
  { label: 'ContentCut', key: 'content_cut' },
  {
    label: 'ContentPaste',
    key: 'content_paste',
  },
  { label: 'ContentPasteGo', key: 'content_paste_go' },
  {
    label: 'ContentPasteOff',
    key: 'content_paste_off',
  },
  { label: 'ContentPasteSearch', key: 'content_paste_search' },
  {
    label: 'Contrast',
    key: 'contrast',
  },
  { label: 'ControlCamera', key: 'control_camera' },
  {
    label: 'ControlPoint',
    key: 'control_point',
  },
  { label: 'ControlPointDuplicate', key: 'control_point_duplicate' },
  {
    label: 'Cookie',
    key: 'cookie',
  },
  { label: 'CopyAll', key: 'copy_all' },
  { label: 'Copyright', key: 'copyright' },
  {
    label: 'Coronavirus',
    key: 'coronavirus',
  },
  { label: 'CorporateFare', key: 'corporate_fare' },
  {
    label: 'Cottage',
    key: 'cottage',
  },
  { label: 'Countertops', key: 'countertops' },
  {
    label: 'Create',
    key: 'create',
  },
  { label: 'CreateNewFolder', key: 'create_new_folder' },
  {
    label: 'CreditCard',
    key: 'credit_card',
  },
  { label: 'CreditCardOff', key: 'credit_card_off' },
  {
    label: 'CreditScore',
    key: 'credit_score',
  },
  { label: 'Crib', key: 'crib' },
  { label: 'CrisisAlert', key: 'crisis_alert' },
  {
    label: 'Crop',
    key: 'crop',
  },
  { label: 'Crop169', key: 'crop_169' },
  { label: 'Crop32', key: 'crop_32' },
  {
    label: 'Crop54',
    key: 'crop_54',
  },
  { label: 'Crop75', key: 'crop_75' },
  { label: 'CropDin', key: 'crop_din' },
  {
    label: 'CropFree',
    key: 'crop_free',
  },
  { label: 'CropLandscape', key: 'crop_landscape' },
  {
    label: 'CropOriginal',
    key: 'crop_original',
  },
  { label: 'CropPortrait', key: 'crop_portrait' },
  {
    label: 'CropRotate',
    key: 'crop_rotate',
  },
  { label: 'CropSquare', key: 'crop_square' },
  { label: 'Css', key: 'css' },
  {
    label: 'CurrencyBitcoin',
    key: 'currency_bitcoin',
  },
  { label: 'CurrencyExchange', key: 'currency_exchange' },
  {
    label: 'CurrencyFranc',
    key: 'currency_franc',
  },
  { label: 'CurrencyLira', key: 'currency_lira' },
  {
    label: 'CurrencyPound',
    key: 'currency_pound',
  },
  { label: 'CurrencyRuble', key: 'currency_ruble' },
  {
    label: 'CurrencyRupee',
    key: 'currency_rupee',
  },
  { label: 'CurrencyYen', key: 'currency_yen' },
  {
    label: 'CurrencyYuan',
    key: 'currency_yuan',
  },
  { label: 'Curtains', key: 'curtains' },
  {
    label: 'CurtainsClosed',
    key: 'curtains_closed',
  },
  { label: 'Cyclone', key: 'cyclone' },
  { label: 'Dangerous', key: 'dangerous' },
  {
    label: 'DarkMode',
    key: 'dark_mode',
  },
  { label: 'Dashboard', key: 'dashboard' },
  {
    label: 'DashboardCustomize',
    key: 'dashboard_customize',
  },
  { label: 'DataArray', key: 'data_array' },
  {
    label: 'DataObject',
    key: 'data_object',
  },
  { label: 'DataSaverOff', key: 'data_saver_off' },
  {
    label: 'DataSaverOn',
    key: 'data_saver_on',
  },
  { label: 'DataThresholding', key: 'data_thresholding' },
  {
    label: 'DataUsage',
    key: 'data_usage',
  },
  { label: 'Dataset', key: 'dataset' },
  {
    label: 'DatasetLinked',
    key: 'dataset_linked',
  },
  { label: 'DateRange', key: 'date_range' },
  { label: 'Deblur', key: 'deblur' },
  {
    label: 'Deck',
    key: 'deck',
  },
  { label: 'Dehaze', key: 'dehaze' },
  { label: 'Delete', key: 'delete' },
  {
    label: 'DeleteForever',
    key: 'delete_forever',
  },
  { label: 'DeleteOutline', key: 'delete_outline' },
  {
    label: 'DeleteSweep',
    key: 'delete_sweep',
  },
  { label: 'DeliveryDining', key: 'delivery_dining' },
  {
    label: 'DensityLarge',
    key: 'density_large',
  },
  { label: 'DensityMedium', key: 'density_medium' },
  {
    label: 'DensitySmall',
    key: 'density_small',
  },
  { label: 'DepartureBoard', key: 'departure_board' },
  {
    label: 'Description',
    key: 'description',
  },
  { label: 'Deselect', key: 'deselect' },
  {
    label: 'DesignServices',
    key: 'design_services',
  },
  { label: 'Desk', key: 'desk' },
  {
    label: 'DesktopAccessDisabled',
    key: 'desktop_access_disabled',
  },
  { label: 'DesktopMac', key: 'desktop_mac' },
  {
    label: 'DesktopWindows',
    key: 'desktop_windows',
  },
  { label: 'Details', key: 'details' },
  {
    label: 'DeveloperBoard',
    key: 'developer_board',
  },
  { label: 'DeveloperBoardOff', key: 'developer_board_off' },
  {
    label: 'DeveloperMode',
    key: 'developer_mode',
  },
  { label: 'DeviceHub', key: 'device_hub' },
  {
    label: 'DeviceThermostat',
    key: 'device_thermostat',
  },
  { label: 'DeviceUnknown', key: 'device_unknown' },
  {
    label: 'Devices',
    key: 'devices',
  },
  { label: 'DevicesFold', key: 'devices_fold' },
  {
    label: 'DevicesOther',
    key: 'devices_other',
  },
  { label: 'DialerSip', key: 'dialer_sip' },
  { label: 'Dialpad', key: 'dialpad' },
  {
    label: 'Diamond',
    key: 'diamond',
  },
  { label: 'Difference', key: 'difference' },
  { label: 'Dining', key: 'dining' },
  {
    label: 'DinnerDining',
    key: 'dinner_dining',
  },
  { label: 'Directions', key: 'directions' },
  {
    label: 'DirectionsBike',
    key: 'directions_bike',
  },
  { label: 'DirectionsBoat', key: 'directions_boat' },
  {
    label: 'DirectionsBoatFilled',
    key: 'directions_boat_filled',
  },
  { label: 'DirectionsBus', key: 'directions_bus' },
  {
    label: 'DirectionsBusFilled',
    key: 'directions_bus_filled',
  },
  { label: 'DirectionsCar', key: 'directions_car' },
  {
    label: 'DirectionsCarFilled',
    key: 'directions_car_filled',
  },
  { label: 'DirectionsOff', key: 'directions_off' },
  {
    label: 'DirectionsRailway',
    key: 'directions_railway',
  },
  { label: 'DirectionsRailwayFilled', key: 'directions_railway_filled' },
  {
    label: 'DirectionsRun',
    key: 'directions_run',
  },
  { label: 'DirectionsSubway', key: 'directions_subway' },
  {
    label: 'DirectionsSubwayFilled',
    key: 'directions_subway_filled',
  },
  { label: 'DirectionsTransit', key: 'directions_transit' },
  {
    label: 'DirectionsTransitFilled',
    key: 'directions_transit_filled',
  },
  { label: 'DirectionsWalk', key: 'directions_walk' },
  {
    label: 'DirtyLens',
    key: 'dirty_lens',
  },
  { label: 'DisabledByDefault', key: 'disabled_by_default' },
  {
    label: 'DiscFull',
    key: 'disc_full',
  },
  { label: 'Discount', key: 'discount' },
  {
    label: 'DisplaySettings',
    key: 'display_settings',
  },
  { label: 'Diversity1', key: 'diversity_1' },
  {
    label: 'Diversity2',
    key: 'diversity_2',
  },
  { label: 'Diversity3', key: 'diversity_3' },
  { label: 'Dns', key: 'dns' },
  {
    label: 'DoDisturb',
    key: 'do_disturb',
  },
  { label: 'DoDisturbAlt', key: 'do_disturb_alt' },
  {
    label: 'DoDisturbOff',
    key: 'do_disturb_off',
  },
  { label: 'DoDisturbOn', key: 'do_disturb_on' },
  {
    label: 'DoNotDisturb',
    key: 'do_not_disturb',
  },
  { label: 'DoNotDisturbAlt', key: 'do_not_disturb_alt' },
  {
    label: 'DoNotDisturbOff',
    key: 'do_not_disturb_off',
  },
  { label: 'DoNotDisturbOn', key: 'do_not_disturb_on' },
  {
    label: 'DoNotDisturbOnTotalSilence',
    key: 'do_not_disturb_on_total_silence',
  },
  { label: 'DoNotStep', key: 'do_not_step' },
  {
    label: 'DoNotTouch',
    key: 'do_not_touch',
  },
  { label: 'Dock', key: 'dock' },
  { label: 'DocumentScanner', key: 'document_scanner' },
  {
    label: 'Domain',
    key: 'domain',
  },
  { label: 'DomainAdd', key: 'domain_add' },
  {
    label: 'DomainDisabled',
    key: 'domain_disabled',
  },
  { label: 'DomainVerification', key: 'domain_verification' },
  {
    label: 'Done',
    key: 'done',
  },
  { label: 'DoneAll', key: 'done_all' },
  {
    label: 'DoneOutline',
    key: 'done_outline',
  },
  { label: 'DonutLarge', key: 'donut_large' },
  {
    label: 'DonutSmall',
    key: 'donut_small',
  },
  { label: 'DoorBack', key: 'door_back' },
  {
    label: 'DoorFront',
    key: 'door_front',
  },
  { label: 'DoorSliding', key: 'door_sliding' },
  {
    label: 'Doorbell',
    key: 'doorbell',
  },
  { label: 'DoubleArrow', key: 'double_arrow' },
  {
    label: 'DownhillSkiing',
    key: 'downhill_skiing',
  },
  { label: 'Download', key: 'download' },
  {
    label: 'DownloadDone',
    key: 'download_done',
  },
  { label: 'DownloadForOffline', key: 'download_for_offline' },
  {
    label: 'Downloading',
    key: 'downloading',
  },
  { label: 'Drafts', key: 'drafts' },
  {
    label: 'DragHandle',
    key: 'drag_handle',
  },
  { label: 'DragIndicator', key: 'drag_indicator' },
  {
    label: 'DriveEta',
    key: 'drive_eta',
  },
  { label: 'DriveFileMove', key: 'drive_file_move' },
  {
    label: 'DriveFileRenameOutline',
    key: 'drive_file_rename_outline',
  },
  { label: 'DriveFolderUpload', key: 'drive_folder_upload' },
  {
    label: 'Dry',
    key: 'dry',
  },
  { label: 'DryCleaning', key: 'dry_cleaning' },
  { label: 'Duo', key: 'duo' },
  {
    label: 'Dvr',
    key: 'dvr',
  },
  { label: 'DynamicFeed', key: 'dynamic_feed' },
  {
    label: 'DynamicForm',
    key: 'dynamic_form',
  },
  { label: 'EMobiledata', key: 'e_mobiledata' },
  {
    label: 'Earbuds',
    key: 'earbuds',
  },
  { label: 'EarbudsBattery', key: 'earbuds_battery' },
  {
    label: 'East',
    key: 'east',
  },
  { label: 'EdgesensorHigh', key: 'edgesensor_high' },
  {
    label: 'EdgesensorLow',
    key: 'edgesensor_low',
  },
  { label: 'Edit', key: 'edit' },
  {
    label: 'EditAttributes',
    key: 'edit_attributes',
  },
  { label: 'EditLocation', key: 'edit_location' },
  {
    label: 'EditLocationAlt',
    key: 'edit_location_alt',
  },
  { label: 'EditNotifications', key: 'edit_notifications' },
  {
    label: 'EditOff',
    key: 'edit_off',
  },
  { label: 'EditRoad', key: 'edit_road' },
  { label: 'Egg', key: 'egg' },
  {
    label: 'EggAlt',
    key: 'egg_alt',
  },
  { label: 'EightK', key: 'eight_k' },
  { label: 'EightKPlus', key: 'eight_k_plus' },
  {
    label: 'EightMp',
    key: 'eight_mp',
  },
  { label: 'EighteenMp', key: 'eighteen_mp' },
  {
    label: 'EighteenUpRating',
    key: 'eighteen_up_rating',
  },
  { label: 'EightteenMp', key: 'eightteen_mp' },
  { label: 'Eject', key: 'eject' },
  {
    label: 'Elderly',
    key: 'elderly',
  },
  { label: 'ElderlyWoman', key: 'elderly_woman' },
  {
    label: 'ElectricBike',
    key: 'electric_bike',
  },
  { label: 'ElectricBolt', key: 'electric_bolt' },
  {
    label: 'ElectricCar',
    key: 'electric_car',
  },
  { label: 'ElectricMeter', key: 'electric_meter' },
  {
    label: 'ElectricMoped',
    key: 'electric_moped',
  },
  { label: 'ElectricRickshaw', key: 'electric_rickshaw' },
  {
    label: 'ElectricScooter',
    key: 'electric_scooter',
  },
  { label: 'ElectricalServices', key: 'electrical_services' },
  {
    label: 'Elevator',
    key: 'elevator',
  },
  { label: 'ElevenMp', key: 'eleven_mp' },
  { label: 'Email', key: 'email' },
  {
    label: 'EmergencyRecording',
    key: 'emergency_recording',
  },
  { label: 'EmergencyShare', key: 'emergency_share' },
  {
    label: 'EmojiEmotions',
    key: 'emoji_emotions',
  },
  { label: 'EmojiEvents', key: 'emoji_events' },
  {
    label: 'EmojiFlags',
    key: 'emoji_flags',
  },
  { label: 'EmojiFoodBeverage', key: 'emoji_food_beverage' },
  {
    label: 'EmojiNature',
    key: 'emoji_nature',
  },
  { label: 'EmojiObjects', key: 'emoji_objects' },
  {
    label: 'EmojiPeople',
    key: 'emoji_people',
  },
  { label: 'EmojiSymbols', key: 'emoji_symbols' },
  {
    label: 'EmojiTransportation',
    key: 'emoji_transportation',
  },
  { label: 'EnergySavingsLeaf', key: 'energy_savings_leaf' },
  {
    label: 'Engineering',
    key: 'engineering',
  },
  { label: 'EnhancedEncryption', key: 'enhanced_encryption' },
  {
    label: 'Equalizer',
    key: 'equalizer',
  },
  { label: 'Error', key: 'error' },
  { label: 'ErrorOutline', key: 'error_outline' },
  {
    label: 'Escalator',
    key: 'escalator',
  },
  { label: 'EscalatorWarning', key: 'escalator_warning' },
  {
    label: 'Euro',
    key: 'euro',
  },
  { label: 'EuroSymbol', key: 'euro_symbol' },
  { label: 'EvStation', key: 'ev_station' },
  {
    label: 'Event',
    key: 'event',
  },
  { label: 'EventAvailable', key: 'event_available' },
  {
    label: 'EventBusy',
    key: 'event_busy',
  },
  { label: 'EventNote', key: 'event_note' },
  {
    label: 'EventRepeat',
    key: 'event_repeat',
  },
  { label: 'EventSeat', key: 'event_seat' },
  { label: 'ExitToApp', key: 'exit_to_app' },
  {
    label: 'Expand',
    key: 'expand',
  },
  { label: 'ExpandCircleDown', key: 'expand_circle_down' },
  {
    label: 'ExpandLess',
    key: 'expand_less',
  },
  { label: 'ExpandMore', key: 'expand_more' },
  { label: 'Explicit', key: 'explicit' },
  {
    label: 'Explore',
    key: 'explore',
  },
  { label: 'ExploreOff', key: 'explore_off' },
  {
    label: 'Exposure',
    key: 'exposure',
  },
  { label: 'Extension', key: 'extension' },
  {
    label: 'ExtensionOff',
    key: 'extension_off',
  },
  { label: 'Face', key: 'face' },
  { label: 'Face2', key: 'face_2' },
  {
    label: 'Face3',
    key: 'face_3',
  },
  { label: 'Face4', key: 'face_4' },
  { label: 'Face5', key: 'face_5' },
  {
    label: 'Face6',
    key: 'face_6',
  },
  { label: 'FaceRetouchingNatural', key: 'face_retouching_natural' },
  {
    label: 'FaceRetouchingOff',
    key: 'face_retouching_off',
  },
  { label: 'Facebook', key: 'facebook' },
  { label: 'FactCheck', key: 'fact_check' },
  {
    label: 'Factory',
    key: 'factory',
  },
  { label: 'FamilyRestroom', key: 'family_restroom' },
  {
    label: 'FastForward',
    key: 'fast_forward',
  },
  { label: 'FastRewind', key: 'fast_rewind' },
  { label: 'Fastfood', key: 'fastfood' },
  {
    label: 'Favorite',
    key: 'favorite',
  },
  { label: 'FavoriteBorder', key: 'favorite_border' },
  {
    label: 'Fax',
    key: 'fax',
  },
  { label: 'FeaturedPlayList', key: 'featured_play_list' },
  {
    label: 'FeaturedVideo',
    key: 'featured_video',
  },
  { label: 'Feed', key: 'feed' },
  { label: 'Feedback', key: 'feedback' },
  {
    label: 'Female',
    key: 'female',
  },
  { label: 'Fence', key: 'fence' },
  { label: 'Festival', key: 'festival' },
  {
    label: 'FiberDvr',
    key: 'fiber_dvr',
  },
  { label: 'FiberManualRecord', key: 'fiber_manual_record' },
  {
    label: 'FiberNew',
    key: 'fiber_new',
  },
  { label: 'FiberPin', key: 'fiber_pin' },
  {
    label: 'FiberSmartRecord',
    key: 'fiber_smart_record',
  },
  { label: 'FifteenMp', key: 'fifteen_mp' },
  {
    label: 'FileCopy',
    key: 'file_copy',
  },
  { label: 'FileDownload', key: 'file_download' },
  {
    label: 'FileDownloadDone',
    key: 'file_download_done',
  },
  { label: 'FileDownloadOff', key: 'file_download_off' },
  {
    label: 'FileOpen',
    key: 'file_open',
  },
  { label: 'FilePresent', key: 'file_present' },
  {
    label: 'FileUpload',
    key: 'file_upload',
  },
  { label: 'Filter', key: 'filter' },
  { label: 'Filter1', key: 'filter_1' },
  {
    label: 'Filter2',
    key: 'filter_2',
  },
  { label: 'Filter3', key: 'filter_3' },
  { label: 'Filter4', key: 'filter_4' },
  {
    label: 'Filter5',
    key: 'filter_5',
  },
  { label: 'Filter6', key: 'filter_6' },
  { label: 'Filter7', key: 'filter_7' },
  {
    label: 'Filter8',
    key: 'filter_8',
  },
  { label: 'Filter9', key: 'filter_9' },
  {
    label: 'Filter9Plus',
    key: 'filter_9_plus',
  },
  { label: 'FilterAlt', key: 'filter_alt' },
  {
    label: 'FilterAltOff',
    key: 'filter_alt_off',
  },
  { label: 'FilterBAndW', key: 'filter_b_and_w' },
  {
    label: 'FilterCenterFocus',
    key: 'filter_center_focus',
  },
  { label: 'FilterDrama', key: 'filter_drama' },
  {
    label: 'FilterFrames',
    key: 'filter_frames',
  },
  { label: 'FilterHdr', key: 'filter_hdr' },
  {
    label: 'FilterList',
    key: 'filter_list',
  },
  { label: 'FilterListOff', key: 'filter_list_off' },
  {
    label: 'FilterNone',
    key: 'filter_none',
  },
  { label: 'FilterTiltShift', key: 'filter_tilt_shift' },
  {
    label: 'FilterVintage',
    key: 'filter_vintage',
  },
  { label: 'FindInPage', key: 'find_in_page' },
  {
    label: 'FindReplace',
    key: 'find_replace',
  },
  { label: 'Fingerprint', key: 'fingerprint' },
  {
    label: 'FireExtinguisher',
    key: 'fire_extinguisher',
  },
  { label: 'FireHydrantAlt', key: 'fire_hydrant_alt' },
  {
    label: 'FireTruck',
    key: 'fire_truck',
  },
  { label: 'Fireplace', key: 'fireplace' },
  {
    label: 'FirstPage',
    key: 'first_page',
  },
  { label: 'FitScreen', key: 'fit_screen' },
  { label: 'Fitbit', key: 'fitbit' },
  {
    label: 'FitnessCenter',
    key: 'fitness_center',
  },
  { label: 'FiveG', key: 'five_g' },
  { label: 'FiveK', key: 'five_k' },
  {
    label: 'FiveKPlus',
    key: 'five_k_plus',
  },
  { label: 'FiveMp', key: 'five_mp' },
  { label: 'FivteenMp', key: 'fivteen_mp' },
  {
    label: 'Flag',
    key: 'flag',
  },
  { label: 'FlagCircle', key: 'flag_circle' },
  { label: 'Flaky', key: 'flaky' },
  {
    label: 'Flare',
    key: 'flare',
  },
  { label: 'FlashAuto', key: 'flash_auto' },
  { label: 'FlashOff', key: 'flash_off' },
  {
    label: 'FlashOn',
    key: 'flash_on',
  },
  { label: 'FlashlightOff', key: 'flashlight_off' },
  {
    label: 'FlashlightOn',
    key: 'flashlight_on',
  },
  { label: 'Flatware', key: 'flatware' },
  { label: 'Flight', key: 'flight' },
  {
    label: 'FlightClass',
    key: 'flight_class',
  },
  { label: 'FlightLand', key: 'flight_land' },
  {
    label: 'FlightTakeoff',
    key: 'flight_takeoff',
  },
  { label: 'Flip', key: 'flip' },
  {
    label: 'FlipCameraAndroid',
    key: 'flip_camera_android',
  },
  { label: 'FlipCameraIos', key: 'flip_camera_ios' },
  {
    label: 'FlipToBack',
    key: 'flip_to_back',
  },
  { label: 'FlipToFront', key: 'flip_to_front' },
  { label: 'Flood', key: 'flood' },
  {
    label: 'Fluorescent',
    key: 'fluorescent',
  },
  { label: 'FlutterDash', key: 'flutter_dash' },
  { label: 'FmdBad', key: 'fmd_bad' },
  {
    label: 'FmdGood',
    key: 'fmd_good',
  },
  { label: 'Folder', key: 'folder' },
  { label: 'FolderCopy', key: 'folder_copy' },
  {
    label: 'FolderDelete',
    key: 'folder_delete',
  },
  { label: 'FolderOff', key: 'folder_off' },
  {
    label: 'FolderOpen',
    key: 'folder_open',
  },
  { label: 'FolderShared', key: 'folder_shared' },
  {
    label: 'FolderSpecial',
    key: 'folder_special',
  },
  { label: 'FolderZip', key: 'folder_zip' },
  {
    label: 'FollowTheSigns',
    key: 'follow_the_signs',
  },
  { label: 'FontDownload', key: 'font_download' },
  {
    label: 'FontDownloadOff',
    key: 'font_download_off',
  },
  { label: 'FoodBank', key: 'food_bank' },
  { label: 'Forest', key: 'forest' },
  {
    label: 'ForkLeft',
    key: 'fork_left',
  },
  { label: 'ForkRight', key: 'fork_right' },
  {
    label: 'FormatAlignCenter',
    key: 'format_align_center',
  },
  { label: 'FormatAlignJustify', key: 'format_align_justify' },
  {
    label: 'FormatAlignLeft',
    key: 'format_align_left',
  },
  { label: 'FormatAlignRight', key: 'format_align_right' },
  {
    label: 'FormatBold',
    key: 'format_bold',
  },
  { label: 'FormatClear', key: 'format_clear' },
  {
    label: 'FormatColorFill',
    key: 'format_color_fill',
  },
  { label: 'FormatColorReset', key: 'format_color_reset' },
  {
    label: 'FormatColorText',
    key: 'format_color_text',
  },
  { label: 'FormatIndentDecrease', key: 'format_indent_decrease' },
  {
    label: 'FormatIndentIncrease',
    key: 'format_indent_increase',
  },
  { label: 'FormatItalic', key: 'format_italic' },
  {
    label: 'FormatLineSpacing',
    key: 'format_line_spacing',
  },
  { label: 'FormatListBulleted', key: 'format_list_bulleted' },
  {
    label: 'FormatListNumbered',
    key: 'format_list_numbered',
  },
  { label: 'FormatListNumberedRtl', key: 'format_list_numbered_rtl' },
  {
    label: 'FormatOverline',
    key: 'format_overline',
  },
  { label: 'FormatPaint', key: 'format_paint' },
  {
    label: 'FormatQuote',
    key: 'format_quote',
  },
  { label: 'FormatShapes', key: 'format_shapes' },
  {
    label: 'FormatSize',
    key: 'format_size',
  },
  { label: 'FormatStrikethrough', key: 'format_strikethrough' },
  {
    label: 'FormatTextdirectionLToR',
    key: 'format_textdirection_l_to_r',
  },
  { label: 'FormatTextdirectionRToL', key: 'format_textdirection_r_to_l' },
  {
    label: 'FormatUnderlined',
    key: 'format_underlined',
  },
  { label: 'Fort', key: 'fort' },
  { label: 'Forum', key: 'forum' },
  {
    label: 'Forward',
    key: 'forward',
  },
  { label: 'Forward10', key: 'forward_10' },
  {
    label: 'Forward30',
    key: 'forward_30',
  },
  { label: 'Forward5', key: 'forward_5' },
  {
    label: 'ForwardToInbox',
    key: 'forward_to_inbox',
  },
  { label: 'Foundation', key: 'foundation' },
  {
    label: 'FourGMobiledata',
    key: 'four_g_mobiledata',
  },
  { label: 'FourGPlusMobiledata', key: 'four_g_plus_mobiledata' },
  {
    label: 'FourK',
    key: 'four_k',
  },
  { label: 'FourKPlus', key: 'four_k_plus' },
  { label: 'FourMp', key: 'four_mp' },
  {
    label: 'FourteenMp',
    key: 'fourteen_mp',
  },
  { label: 'FreeBreakfast', key: 'free_breakfast' },
  {
    label: 'Fullscreen',
    key: 'fullscreen',
  },
  { label: 'FullscreenExit', key: 'fullscreen_exit' },
  {
    label: 'Functions',
    key: 'functions',
  },
  { label: 'GMobiledata', key: 'g_mobiledata' },
  {
    label: 'GTranslate',
    key: 'g_translate',
  },
  { label: 'Gamepad', key: 'gamepad' },
  { label: 'Games', key: 'games' },
  {
    label: 'Garage',
    key: 'garage',
  },
  { label: 'GasMeter', key: 'gas_meter' },
  { label: 'Gavel', key: 'gavel' },
  {
    label: 'Gesture',
    key: 'gesture',
  },
  { label: 'GetApp', key: 'get_app' },
  { label: 'Gif', key: 'gif' },
  {
    label: 'GifBox',
    key: 'gif_box',
  },
  { label: 'Girl', key: 'girl' },
  { label: 'GitHub', key: 'git_hub' },
  {
    label: 'Gite',
    key: 'gite',
  },
  { label: 'GolfCourse', key: 'golf_course' },
  { label: 'Google', key: 'google' },
  {
    label: 'GppBad',
    key: 'gpp_bad',
  },
  { label: 'GppGood', key: 'gpp_good' },
  { label: 'GppMaybe', key: 'gpp_maybe' },
  {
    label: 'GpsFixed',
    key: 'gps_fixed',
  },
  { label: 'GpsNotFixed', key: 'gps_not_fixed' },
  { label: 'GpsOff', key: 'gps_off' },
  {
    label: 'Grade',
    key: 'grade',
  },
  { label: 'Gradient', key: 'gradient' },
  { label: 'Grading', key: 'grading' },
  {
    label: 'Grain',
    key: 'grain',
  },
  { label: 'GraphicEq', key: 'graphic_eq' },
  { label: 'Grass', key: 'grass' },
  {
    label: 'Grid3x3',
    key: 'grid_3_x_3',
  },
  { label: 'Grid4x4', key: 'grid_4_x_4' },
  {
    label: 'GridGoldenratio',
    key: 'grid_goldenratio',
  },
  { label: 'GridOff', key: 'grid_off' },
  { label: 'GridOn', key: 'grid_on' },
  {
    label: 'GridView',
    key: 'grid_view',
  },
  { label: 'Group', key: 'group' },
  { label: 'GroupAdd', key: 'group_add' },
  {
    label: 'GroupRemove',
    key: 'group_remove',
  },
  { label: 'GroupWork', key: 'group_work' },
  { label: 'Groups', key: 'groups' },
  {
    label: 'Groups2',
    key: 'groups_2',
  },
  { label: 'Groups3', key: 'groups_3' },
  {
    label: 'HMobiledata',
    key: 'h_mobiledata',
  },
  { label: 'HPlusMobiledata', key: 'h_plus_mobiledata' },
  {
    label: 'Hail',
    key: 'hail',
  },
  { label: 'Handshake', key: 'handshake' },
  { label: 'Handyman', key: 'handyman' },
  {
    label: 'Hardware',
    key: 'hardware',
  },
  { label: 'Hd', key: 'hd' },
  { label: 'HdrAuto', key: 'hdr_auto' },
  {
    label: 'HdrAutoSelect',
    key: 'hdr_auto_select',
  },
  { label: 'HdrEnhancedSelect', key: 'hdr_enhanced_select' },
  {
    label: 'HdrOff',
    key: 'hdr_off',
  },
  { label: 'HdrOffSelect', key: 'hdr_off_select' },
  {
    label: 'HdrOn',
    key: 'hdr_on',
  },
  { label: 'HdrOnSelect', key: 'hdr_on_select' },
  {
    label: 'HdrPlus',
    key: 'hdr_plus',
  },
  { label: 'HdrStrong', key: 'hdr_strong' },
  { label: 'HdrWeak', key: 'hdr_weak' },
  {
    label: 'Headphones',
    key: 'headphones',
  },
  { label: 'HeadphonesBattery', key: 'headphones_battery' },
  {
    label: 'Headset',
    key: 'headset',
  },
  { label: 'HeadsetMic', key: 'headset_mic' },
  {
    label: 'HeadsetOff',
    key: 'headset_off',
  },
  { label: 'Healing', key: 'healing' },
  {
    label: 'HealthAndSafety',
    key: 'health_and_safety',
  },
  { label: 'Hearing', key: 'hearing' },
  {
    label: 'HearingDisabled',
    key: 'hearing_disabled',
  },
  { label: 'HeartBroken', key: 'heart_broken' },
  {
    label: 'HeatPump',
    key: 'heat_pump',
  },
  { label: 'Height', key: 'height' },
  { label: 'Help', key: 'help' },
  {
    label: 'HelpCenter',
    key: 'help_center',
  },
  { label: 'HelpOutline', key: 'help_outline' },
  { label: 'Hevc', key: 'hevc' },
  {
    label: 'Hexagon',
    key: 'hexagon',
  },
  { label: 'HideImage', key: 'hide_image' },
  {
    label: 'HideSource',
    key: 'hide_source',
  },
  { label: 'HighQuality', key: 'high_quality' },
  {
    label: 'Highlight',
    key: 'highlight',
  },
  { label: 'HighlightAlt', key: 'highlight_alt' },
  {
    label: 'HighlightOff',
    key: 'highlight_off',
  },
  { label: 'Hiking', key: 'hiking' },
  { label: 'History', key: 'history' },
  {
    label: 'HistoryEdu',
    key: 'history_edu',
  },
  { label: 'HistoryToggleOff', key: 'history_toggle_off' },
  { label: 'Hive', key: 'hive' },
  {
    label: 'Hls',
    key: 'hls',
  },
  { label: 'HlsOff', key: 'hls_off' },
  {
    label: 'HolidayVillage',
    key: 'holiday_village',
  },
  { label: 'Home', key: 'home' },
  { label: 'HomeMax', key: 'home_max' },
  {
    label: 'HomeMini',
    key: 'home_mini',
  },
  { label: 'HomeRepairService', key: 'home_repair_service' },
  {
    label: 'HomeWork',
    key: 'home_work',
  },
  { label: 'HorizontalRule', key: 'horizontal_rule' },
  {
    label: 'HorizontalSplit',
    key: 'horizontal_split',
  },
  { label: 'HotTub', key: 'hot_tub' },
  { label: 'Hotel', key: 'hotel' },
  {
    label: 'HourglassBottom',
    key: 'hourglass_bottom',
  },
  { label: 'HourglassDisabled', key: 'hourglass_disabled' },
  {
    label: 'HourglassEmpty',
    key: 'hourglass_empty',
  },
  { label: 'HourglassFull', key: 'hourglass_full' },
  {
    label: 'HourglassTop',
    key: 'hourglass_top',
  },
  { label: 'House', key: 'house' },
  { label: 'HouseSiding', key: 'house_siding' },
  {
    label: 'Houseboat',
    key: 'houseboat',
  },
  { label: 'HowToReg', key: 'how_to_reg' },
  { label: 'HowToVote', key: 'how_to_vote' },
  {
    label: 'Html',
    key: 'html',
  },
  { label: 'Http', key: 'http' },
  { label: 'Https', key: 'https' },
  {
    label: 'Hub',
    key: 'hub',
  },
  { label: 'Hvac', key: 'hvac' },
  { label: 'IceSkating', key: 'ice_skating' },
  {
    label: 'Icecream',
    key: 'icecream',
  },
  { label: 'Image', key: 'image' },
  {
    label: 'ImageAspectRatio',
    key: 'image_aspect_ratio',
  },
  { label: 'ImageNotSupported', key: 'image_not_supported' },
  {
    label: 'ImageSearch',
    key: 'image_search',
  },
  { label: 'ImagesearchRoller', key: 'imagesearch_roller' },
  {
    label: 'ImportContacts',
    key: 'import_contacts',
  },
  { label: 'ImportExport', key: 'import_export' },
  {
    label: 'ImportantDevices',
    key: 'important_devices',
  },
  { label: 'Inbox', key: 'inbox' },
  {
    label: 'IndeterminateCheckBox',
    key: 'indeterminate_check_box',
  },
  { label: 'Info', key: 'info' },
  { label: 'Input', key: 'input' },
  {
    label: 'InsertChart',
    key: 'insert_chart',
  },
  { label: 'InsertComment', key: 'insert_comment' },
  {
    label: 'InsertDriveFile',
    key: 'insert_drive_file',
  },
  { label: 'InsertEmoticon', key: 'insert_emoticon' },
  {
    label: 'InsertInvitation',
    key: 'insert_invitation',
  },
  { label: 'InsertLink', key: 'insert_link' },
  {
    label: 'InsertPageBreak',
    key: 'insert_page_break',
  },
  { label: 'InsertPhoto', key: 'insert_photo' },
  {
    label: 'Insights',
    key: 'insights',
  },
  { label: 'Instagram', key: 'instagram' },
  {
    label: 'InstallDesktop',
    key: 'install_desktop',
  },
  { label: 'InstallMobile', key: 'install_mobile' },
  {
    label: 'IntegrationInstructions',
    key: 'integration_instructions',
  },
  { label: 'Interests', key: 'interests' },
  {
    label: 'InterpreterMode',
    key: 'interpreter_mode',
  },
  { label: 'Inventory', key: 'inventory' },
  {
    label: 'Inventory2',
    key: 'inventory_2',
  },
  { label: 'InvertColors', key: 'invert_colors' },
  {
    label: 'InvertColorsOff',
    key: 'invert_colors_off',
  },
  { label: 'IosShare', key: 'ios_share' },
  { label: 'Iron', key: 'iron' },
  {
    label: 'Iso',
    key: 'iso',
  },
  { label: 'Javascript', key: 'javascript' },
  {
    label: 'JoinFull',
    key: 'join_full',
  },
  { label: 'JoinInner', key: 'join_inner' },
  { label: 'JoinLeft', key: 'join_left' },
  {
    label: 'JoinRight',
    key: 'join_right',
  },
  { label: 'Kayaking', key: 'kayaking' },
  { label: 'KebabDining', key: 'kebab_dining' },
  {
    label: 'Key',
    key: 'key',
  },
  { label: 'KeyOff', key: 'key_off' },
  { label: 'Keyboard', key: 'keyboard' },
  {
    label: 'KeyboardAlt',
    key: 'keyboard_alt',
  },
  { label: 'KeyboardArrowDown', key: 'keyboard_arrow_down' },
  {
    label: 'KeyboardArrowLeft',
    key: 'keyboard_arrow_left',
  },
  { label: 'KeyboardArrowRight', key: 'keyboard_arrow_right' },
  {
    label: 'KeyboardArrowUp',
    key: 'keyboard_arrow_up',
  },
  { label: 'KeyboardBackspace', key: 'keyboard_backspace' },
  {
    label: 'KeyboardCapslock',
    key: 'keyboard_capslock',
  },
  { label: 'KeyboardCommandKey', key: 'keyboard_command_key' },
  {
    label: 'KeyboardControlKey',
    key: 'keyboard_control_key',
  },
  { label: 'KeyboardDoubleArrowDown', key: 'keyboard_double_arrow_down' },
  {
    label: 'KeyboardDoubleArrowLeft',
    key: 'keyboard_double_arrow_left',
  },
  { label: 'KeyboardDoubleArrowRight', key: 'keyboard_double_arrow_right' },
  {
    label: 'KeyboardDoubleArrowUp',
    key: 'keyboard_double_arrow_up',
  },
  { label: 'KeyboardHide', key: 'keyboard_hide' },
  {
    label: 'KeyboardOptionKey',
    key: 'keyboard_option_key',
  },
  { label: 'KeyboardReturn', key: 'keyboard_return' },
  {
    label: 'KeyboardTab',
    key: 'keyboard_tab',
  },
  { label: 'KeyboardVoice', key: 'keyboard_voice' },
  {
    label: 'KingBed',
    key: 'king_bed',
  },
  { label: 'Kitchen', key: 'kitchen' },
  { label: 'Kitesurfing', key: 'kitesurfing' },
  {
    label: 'Label',
    key: 'label',
  },
  { label: 'LabelImportant', key: 'label_important' },
  {
    label: 'LabelOff',
    key: 'label_off',
  },
  { label: 'Lan', key: 'lan' },
  { label: 'Landscape', key: 'landscape' },
  {
    label: 'Landslide',
    key: 'landslide',
  },
  { label: 'Language', key: 'language' },
  { label: 'Laptop', key: 'laptop' },
  {
    label: 'LaptopChromebook',
    key: 'laptop_chromebook',
  },
  { label: 'LaptopMac', key: 'laptop_mac' },
  {
    label: 'LaptopWindows',
    key: 'laptop_windows',
  },
  { label: 'LastPage', key: 'last_page' },
  { label: 'Launch', key: 'launch' },
  {
    label: 'Layers',
    key: 'layers',
  },
  { label: 'LayersClear', key: 'layers_clear' },
  {
    label: 'Leaderboard',
    key: 'leaderboard',
  },
  { label: 'LeakAdd', key: 'leak_add' },
  {
    label: 'LeakRemove',
    key: 'leak_remove',
  },
  { label: 'LegendToggle', key: 'legend_toggle' },
  { label: 'Lens', key: 'lens' },
  {
    label: 'LensBlur',
    key: 'lens_blur',
  },
  { label: 'LibraryAdd', key: 'library_add' },
  {
    label: 'LibraryAddCheck',
    key: 'library_add_check',
  },
  { label: 'LibraryBooks', key: 'library_books' },
  {
    label: 'LibraryMusic',
    key: 'library_music',
  },
  { label: 'Light', key: 'light' },
  { label: 'LightMode', key: 'light_mode' },
  {
    label: 'Lightbulb',
    key: 'lightbulb',
  },
  { label: 'LightbulbCircle', key: 'lightbulb_circle' },
  {
    label: 'LineAxis',
    key: 'line_axis',
  },
  { label: 'LineStyle', key: 'line_style' },
  {
    label: 'LineWeight',
    key: 'line_weight',
  },
  { label: 'LinearScale', key: 'linear_scale' },
  { label: 'Link', key: 'link' },
  {
    label: 'LinkOff',
    key: 'link_off',
  },
  { label: 'LinkedCamera', key: 'linked_camera' },
  {
    label: 'LinkedIn',
    key: 'linked_in',
  },
  { label: 'Liquor', key: 'liquor' },
  { label: 'List', key: 'list' },
  {
    label: 'ListAlt',
    key: 'list_alt',
  },
  { label: 'LiveHelp', key: 'live_help' },
  { label: 'LiveTv', key: 'live_tv' },
  {
    label: 'Living',
    key: 'living',
  },
  { label: 'LocalActivity', key: 'local_activity' },
  {
    label: 'LocalAirport',
    key: 'local_airport',
  },
  { label: 'LocalAtm', key: 'local_atm' },
  { label: 'LocalBar', key: 'local_bar' },
  {
    label: 'LocalCafe',
    key: 'local_cafe',
  },
  { label: 'LocalCarWash', key: 'local_car_wash' },
  {
    label: 'LocalConvenienceStore',
    key: 'local_convenience_store',
  },
  { label: 'LocalDining', key: 'local_dining' },
  {
    label: 'LocalDrink',
    key: 'local_drink',
  },
  { label: 'LocalFireDepartment', key: 'local_fire_department' },
  {
    label: 'LocalFlorist',
    key: 'local_florist',
  },
  { label: 'LocalGasStation', key: 'local_gas_station' },
  {
    label: 'LocalGroceryStore',
    key: 'local_grocery_store',
  },
  { label: 'LocalHospital', key: 'local_hospital' },
  {
    label: 'LocalHotel',
    key: 'local_hotel',
  },
  { label: 'LocalLaundryService', key: 'local_laundry_service' },
  {
    label: 'LocalLibrary',
    key: 'local_library',
  },
  { label: 'LocalMall', key: 'local_mall' },
  {
    label: 'LocalMovies',
    key: 'local_movies',
  },
  { label: 'LocalOffer', key: 'local_offer' },
  {
    label: 'LocalParking',
    key: 'local_parking',
  },
  { label: 'LocalPharmacy', key: 'local_pharmacy' },
  {
    label: 'LocalPhone',
    key: 'local_phone',
  },
  { label: 'LocalPizza', key: 'local_pizza' },
  {
    label: 'LocalPlay',
    key: 'local_play',
  },
  { label: 'LocalPolice', key: 'local_police' },
  {
    label: 'LocalPostOffice',
    key: 'local_post_office',
  },
  { label: 'LocalPrintshop', key: 'local_printshop' },
  {
    label: 'LocalSee',
    key: 'local_see',
  },
  { label: 'LocalShipping', key: 'local_shipping' },
  {
    label: 'LocalTaxi',
    key: 'local_taxi',
  },
  { label: 'LocationCity', key: 'location_city' },
  {
    label: 'LocationDisabled',
    key: 'location_disabled',
  },
  { label: 'LocationOff', key: 'location_off' },
  {
    label: 'LocationOn',
    key: 'location_on',
  },
  { label: 'LocationSearching', key: 'location_searching' },
  {
    label: 'Lock',
    key: 'lock',
  },
  { label: 'LockClock', key: 'lock_clock' },
  {
    label: 'LockOpen',
    key: 'lock_open',
  },
  { label: 'LockPerson', key: 'lock_person' },
  { label: 'LockReset', key: 'lock_reset' },
  {
    label: 'Login',
    key: 'login',
  },
  { label: 'LogoDev', key: 'logo_dev' },
  { label: 'Logout', key: 'logout' },
  {
    label: 'Looks',
    key: 'looks',
  },
  { label: 'Looks3', key: 'looks_3' },
  { label: 'Looks4', key: 'looks_4' },
  {
    label: 'Looks5',
    key: 'looks_5',
  },
  { label: 'Looks6', key: 'looks_6' },
  { label: 'LooksOne', key: 'looks_one' },
  {
    label: 'LooksTwo',
    key: 'looks_two',
  },
  { label: 'Loop', key: 'loop' },
  { label: 'Loupe', key: 'loupe' },
  {
    label: 'LowPriority',
    key: 'low_priority',
  },
  { label: 'Loyalty', key: 'loyalty' },
  {
    label: 'LteMobiledata',
    key: 'lte_mobiledata',
  },
  { label: 'LtePlusMobiledata', key: 'lte_plus_mobiledata' },
  {
    label: 'Luggage',
    key: 'luggage',
  },
  { label: 'LunchDining', key: 'lunch_dining' },
  { label: 'Lyrics', key: 'lyrics' },
  {
    label: 'MacroOff',
    key: 'macro_off',
  },
  { label: 'Mail', key: 'mail' },
  { label: 'MailLock', key: 'mail_lock' },
  {
    label: 'MailOutline',
    key: 'mail_outline',
  },
  { label: 'Male', key: 'male' },
  { label: 'Man', key: 'man' },
  {
    label: 'Man2',
    key: 'man_2',
  },
  { label: 'Man3', key: 'man_3' },
  { label: 'Man4', key: 'man_4' },
  {
    label: 'ManageAccounts',
    key: 'manage_accounts',
  },
  { label: 'ManageHistory', key: 'manage_history' },
  {
    label: 'ManageSearch',
    key: 'manage_search',
  },
  { label: 'Map', key: 'map' },
  { label: 'MapsHomeWork', key: 'maps_home_work' },
  {
    label: 'MapsUgc',
    key: 'maps_ugc',
  },
  { label: 'Margin', key: 'margin' },
  {
    label: 'MarkAsUnread',
    key: 'mark_as_unread',
  },
  { label: 'MarkChatRead', key: 'mark_chat_read' },
  {
    label: 'MarkChatUnread',
    key: 'mark_chat_unread',
  },
  { label: 'MarkEmailRead', key: 'mark_email_read' },
  {
    label: 'MarkEmailUnread',
    key: 'mark_email_unread',
  },
  { label: 'MarkUnreadChatAlt', key: 'mark_unread_chat_alt' },
  {
    label: 'Markunread',
    key: 'markunread',
  },
  { label: 'MarkunreadMailbox', key: 'markunread_mailbox' },
  {
    label: 'Masks',
    key: 'masks',
  },
  { label: 'Maximize', key: 'maximize' },
  {
    label: 'MediaBluetoothOff',
    key: 'media_bluetooth_off',
  },
  { label: 'MediaBluetoothOn', key: 'media_bluetooth_on' },
  {
    label: 'Mediation',
    key: 'mediation',
  },
  { label: 'MedicalInformation', key: 'medical_information' },
  {
    label: 'MedicalServices',
    key: 'medical_services',
  },
  { label: 'Medication', key: 'medication' },
  {
    label: 'MedicationLiquid',
    key: 'medication_liquid',
  },
  { label: 'MeetingRoom', key: 'meeting_room' },
  { label: 'Memory', key: 'memory' },
  {
    label: 'Menu',
    key: 'menu',
  },
  { label: 'MenuBook', key: 'menu_book' },
  { label: 'MenuOpen', key: 'menu_open' },
  {
    label: 'Merge',
    key: 'merge',
  },
  { label: 'MergeType', key: 'merge_type' },
  { label: 'Message', key: 'message' },
  {
    label: 'Mic',
    key: 'mic',
  },
  { label: 'MicExternalOff', key: 'mic_external_off' },
  {
    label: 'MicExternalOn',
    key: 'mic_external_on',
  },
  { label: 'MicNone', key: 'mic_none' },
  { label: 'MicOff', key: 'mic_off' },
  {
    label: 'Microwave',
    key: 'microwave',
  },
  { label: 'MilitaryTech', key: 'military_tech' },
  {
    label: 'Minimize',
    key: 'minimize',
  },
  { label: 'MinorCrash', key: 'minor_crash' },
  {
    label: 'MiscellaneousServices',
    key: 'miscellaneous_services',
  },
  { label: 'MissedVideoCall', key: 'missed_video_call' },
  {
    label: 'Mms',
    key: 'mms',
  },
  { label: 'MobileFriendly', key: 'mobile_friendly' },
  {
    label: 'MobileOff',
    key: 'mobile_off',
  },
  { label: 'MobileScreenShare', key: 'mobile_screen_share' },
  {
    label: 'MobiledataOff',
    key: 'mobiledata_off',
  },
  { label: 'Mode', key: 'mode' },
  { label: 'ModeComment', key: 'mode_comment' },
  {
    label: 'ModeEdit',
    key: 'mode_edit',
  },
  { label: 'ModeEditOutline', key: 'mode_edit_outline' },
  {
    label: 'ModeFanOff',
    key: 'mode_fan_off',
  },
  { label: 'ModeNight', key: 'mode_night' },
  {
    label: 'ModeOfTravel',
    key: 'mode_of_travel',
  },
  { label: 'ModeStandby', key: 'mode_standby' },
  {
    label: 'ModelTraining',
    key: 'model_training',
  },
  { label: 'MonetizationOn', key: 'monetization_on' },
  {
    label: 'Money',
    key: 'money',
  },
  { label: 'MoneyOff', key: 'money_off' },
  {
    label: 'MoneyOffCsred',
    key: 'money_off_csred',
  },
  { label: 'Monitor', key: 'monitor' },
  {
    label: 'MonitorHeart',
    key: 'monitor_heart',
  },
  { label: 'MonitorWeight', key: 'monitor_weight' },
  {
    label: 'MonochromePhotos',
    key: 'monochrome_photos',
  },
  { label: 'Mood', key: 'mood' },
  { label: 'MoodBad', key: 'mood_bad' },
  {
    label: 'Moped',
    key: 'moped',
  },
  { label: 'More', key: 'more' },
  { label: 'MoreHoriz', key: 'more_horiz' },
  {
    label: 'MoreTime',
    key: 'more_time',
  },
  { label: 'MoreVert', key: 'more_vert' },
  { label: 'Mosque', key: 'mosque' },
  {
    label: 'MotionPhotosAuto',
    key: 'motion_photos_auto',
  },
  { label: 'MotionPhotosOff', key: 'motion_photos_off' },
  {
    label: 'Mouse',
    key: 'mouse',
  },
  { label: 'MoveDown', key: 'move_down' },
  {
    label: 'MoveToInbox',
    key: 'move_to_inbox',
  },
  { label: 'MoveUp', key: 'move_up' },
  { label: 'Movie', key: 'movie' },
  {
    label: 'MovieCreation',
    key: 'movie_creation',
  },
  { label: 'MovieFilter', key: 'movie_filter' },
  { label: 'Moving', key: 'moving' },
  {
    label: 'Mp',
    key: 'mp',
  },
  { label: 'MultilineChart', key: 'multiline_chart' },
  {
    label: 'MultipleStop',
    key: 'multiple_stop',
  },
  { label: 'Museum', key: 'museum' },
  { label: 'MusicNote', key: 'music_note' },
  {
    label: 'MusicOff',
    key: 'music_off',
  },
  { label: 'MusicVideo', key: 'music_video' },
  { label: 'MyLocation', key: 'my_location' },
  {
    label: 'Nat',
    key: 'nat',
  },
  { label: 'Nature', key: 'nature' },
  {
    label: 'NaturePeople',
    key: 'nature_people',
  },
  { label: 'NavigateBefore', key: 'navigate_before' },
  {
    label: 'NavigateNext',
    key: 'navigate_next',
  },
  { label: 'Navigation', key: 'navigation' },
  {
    label: 'NearMe',
    key: 'near_me',
  },
  { label: 'NearMeDisabled', key: 'near_me_disabled' },
  {
    label: 'NearbyError',
    key: 'nearby_error',
  },
  { label: 'NearbyOff', key: 'nearby_off' },
  {
    label: 'NestCamWiredStand',
    key: 'nest_cam_wired_stand',
  },
  { label: 'NetworkCell', key: 'network_cell' },
  {
    label: 'NetworkCheck',
    key: 'network_check',
  },
  { label: 'NetworkLocked', key: 'network_locked' },
  {
    label: 'NetworkPing',
    key: 'network_ping',
  },
  { label: 'NetworkWifi', key: 'network_wifi' },
  {
    label: 'NetworkWifi1Bar',
    key: 'network_wifi_1_bar',
  },
  { label: 'NetworkWifi2Bar', key: 'network_wifi_2_bar' },
  {
    label: 'NetworkWifi3Bar',
    key: 'network_wifi_3_bar',
  },
  { label: 'NewReleases', key: 'new_releases' },
  {
    label: 'Newspaper',
    key: 'newspaper',
  },
  { label: 'NextPlan', key: 'next_plan' },
  { label: 'NextWeek', key: 'next_week' },
  {
    label: 'Nfc',
    key: 'nfc',
  },
  { label: 'NightShelter', key: 'night_shelter' },
  {
    label: 'Nightlife',
    key: 'nightlife',
  },
  { label: 'Nightlight', key: 'nightlight' },
  {
    label: 'NightlightRound',
    key: 'nightlight_round',
  },
  { label: 'NightsStay', key: 'nights_stay' },
  { label: 'NineK', key: 'nine_k' },
  {
    label: 'NineKPlus',
    key: 'nine_k_plus',
  },
  { label: 'NineMp', key: 'nine_mp' },
  { label: 'NineteenMp', key: 'nineteen_mp' },
  {
    label: 'NoAccounts',
    key: 'no_accounts',
  },
  { label: 'NoAdultContent', key: 'no_adult_content' },
  {
    label: 'NoBackpack',
    key: 'no_backpack',
  },
  { label: 'NoCell', key: 'no_cell' },
  { label: 'NoCrash', key: 'no_crash' },
  {
    label: 'NoDrinks',
    key: 'no_drinks',
  },
  { label: 'NoEncryption', key: 'no_encryption' },
  {
    label: 'NoEncryptionGmailerrorred',
    key: 'no_encryption_gmailerrorred',
  },
  { label: 'NoFlash', key: 'no_flash' },
  { label: 'NoFood', key: 'no_food' },
  {
    label: 'NoLuggage',
    key: 'no_luggage',
  },
  { label: 'NoMeals', key: 'no_meals' },
  {
    label: 'NoMeetingRoom',
    key: 'no_meeting_room',
  },
  { label: 'NoPhotography', key: 'no_photography' },
  {
    label: 'NoSim',
    key: 'no_sim',
  },
  { label: 'NoStroller', key: 'no_stroller' },
  {
    label: 'NoTransfer',
    key: 'no_transfer',
  },
  { label: 'NoiseAware', key: 'noise_aware' },
  {
    label: 'NoiseControlOff',
    key: 'noise_control_off',
  },
  { label: 'NordicWalking', key: 'nordic_walking' },
  {
    label: 'North',
    key: 'north',
  },
  { label: 'NorthEast', key: 'north_east' },
  {
    label: 'NorthWest',
    key: 'north_west',
  },
  { label: 'NotAccessible', key: 'not_accessible' },
  {
    label: 'NotInterested',
    key: 'not_interested',
  },
  { label: 'NotListedLocation', key: 'not_listed_location' },
  {
    label: 'NotStarted',
    key: 'not_started',
  },
  { label: 'Note', key: 'note' },
  { label: 'NoteAdd', key: 'note_add' },
  {
    label: 'NoteAlt',
    key: 'note_alt',
  },
  { label: 'Notes', key: 'notes' },
  {
    label: 'NotificationAdd',
    key: 'notification_add',
  },
  { label: 'NotificationImportant', key: 'notification_important' },
  {
    label: 'Notifications',
    key: 'notifications',
  },
  { label: 'NotificationsActive', key: 'notifications_active' },
  {
    label: 'NotificationsNone',
    key: 'notifications_none',
  },
  { label: 'NotificationsOff', key: 'notifications_off' },
  {
    label: 'NotificationsPaused',
    key: 'notifications_paused',
  },
  { label: 'Numbers', key: 'numbers' },
  {
    label: 'OfflineBolt',
    key: 'offline_bolt',
  },
  { label: 'OfflinePin', key: 'offline_pin' },
  {
    label: 'OfflineShare',
    key: 'offline_share',
  },
  { label: 'OilBarrel', key: 'oil_barrel' },
  {
    label: 'OnDeviceTraining',
    key: 'on_device_training',
  },
  { label: 'OndemandVideo', key: 'ondemand_video' },
  { label: 'OneK', key: 'one_k' },
  {
    label: 'OneKPlus',
    key: 'one_k_plus',
  },
  { label: 'OneKk', key: 'one_kk' },
  {
    label: 'OnlinePrediction',
    key: 'online_prediction',
  },
  { label: 'Opacity', key: 'opacity' },
  {
    label: 'OpenInBrowser',
    key: 'open_in_browser',
  },
  { label: 'OpenInFull', key: 'open_in_full' },
  {
    label: 'OpenInNew',
    key: 'open_in_new',
  },
  { label: 'OpenInNewOff', key: 'open_in_new_off' },
  {
    label: 'OpenWith',
    key: 'open_with',
  },
  { label: 'OtherHouses', key: 'other_houses' },
  { label: 'Outbound', key: 'outbound' },
  {
    label: 'Outbox',
    key: 'outbox',
  },
  { label: 'OutdoorGrill', key: 'outdoor_grill' },
  { label: 'Outlet', key: 'outlet' },
  {
    label: 'Output',
    key: 'output',
  },
  { label: 'Padding', key: 'padding' },
  { label: 'Pages', key: 'pages' },
  {
    label: 'Pageview',
    key: 'pageview',
  },
  { label: 'Paid', key: 'paid' },
  { label: 'Palette', key: 'palette' },
  {
    label: 'PanTool',
    key: 'pan_tool',
  },
  { label: 'PanToolAlt', key: 'pan_tool_alt' },
  {
    label: 'Panorama',
    key: 'panorama',
  },
  { label: 'PanoramaFishEye', key: 'panorama_fish_eye' },
  {
    label: 'PanoramaHorizontal',
    key: 'panorama_horizontal',
  },
  { label: 'PanoramaHorizontalSelect', key: 'panorama_horizontal_select' },
  {
    label: 'PanoramaPhotosphere',
    key: 'panorama_photosphere',
  },
  { label: 'PanoramaPhotosphereSelect', key: 'panorama_photosphere_select' },
  {
    label: 'PanoramaVertical',
    key: 'panorama_vertical',
  },
  { label: 'PanoramaVerticalSelect', key: 'panorama_vertical_select' },
  {
    label: 'PanoramaWideAngle',
    key: 'panorama_wide_angle',
  },
  { label: 'PanoramaWideAngleSelect', key: 'panorama_wide_angle_select' },
  {
    label: 'Paragliding',
    key: 'paragliding',
  },
  { label: 'Park', key: 'park' },
  { label: 'PartyMode', key: 'party_mode' },
  {
    label: 'Password',
    key: 'password',
  },
  { label: 'Pattern', key: 'pattern' },
  { label: 'Pause', key: 'pause' },
  {
    label: 'PauseCircle',
    key: 'pause_circle',
  },
  { label: 'PauseCircleFilled', key: 'pause_circle_filled' },
  {
    label: 'PauseCircleOutline',
    key: 'pause_circle_outline',
  },
  { label: 'PausePresentation', key: 'pause_presentation' },
  {
    label: 'Payment',
    key: 'payment',
  },
  { label: 'Payments', key: 'payments' },
  { label: 'PedalBike', key: 'pedal_bike' },
  {
    label: 'Pending',
    key: 'pending',
  },
  { label: 'PendingActions', key: 'pending_actions' },
  {
    label: 'Pentagon',
    key: 'pentagon',
  },
  { label: 'People', key: 'people' },
  { label: 'PeopleAlt', key: 'people_alt' },
  {
    label: 'PeopleOutline',
    key: 'people_outline',
  },
  { label: 'Percent', key: 'percent' },
  {
    label: 'PermCameraMic',
    key: 'perm_camera_mic',
  },
  { label: 'PermContactCalendar', key: 'perm_contact_calendar' },
  {
    label: 'PermDataSetting',
    key: 'perm_data_setting',
  },
  { label: 'PermDeviceInformation', key: 'perm_device_information' },
  {
    label: 'PermIdentity',
    key: 'perm_identity',
  },
  { label: 'PermMedia', key: 'perm_media' },
  {
    label: 'PermPhoneMsg',
    key: 'perm_phone_msg',
  },
  { label: 'PermScanWifi', key: 'perm_scan_wifi' },
  { label: 'Person', key: 'person' },
  {
    label: 'Person2',
    key: 'person_2',
  },
  { label: 'Person3', key: 'person_3' },
  { label: 'Person4', key: 'person_4' },
  {
    label: 'PersonAdd',
    key: 'person_add',
  },
  { label: 'PersonAddAlt', key: 'person_add_alt' },
  {
    label: 'PersonAddAlt1',
    key: 'person_add_alt_1',
  },
  { label: 'PersonAddDisabled', key: 'person_add_disabled' },
  {
    label: 'PersonOff',
    key: 'person_off',
  },
  { label: 'PersonOutline', key: 'person_outline' },
  {
    label: 'PersonPin',
    key: 'person_pin',
  },
  { label: 'PersonPinCircle', key: 'person_pin_circle' },
  {
    label: 'PersonRemove',
    key: 'person_remove',
  },
  { label: 'PersonRemoveAlt1', key: 'person_remove_alt_1' },
  {
    label: 'PersonSearch',
    key: 'person_search',
  },
  { label: 'PersonalVideo', key: 'personal_video' },
  {
    label: 'PestControl',
    key: 'pest_control',
  },
  { label: 'PestControlRodent', key: 'pest_control_rodent' },
  {
    label: 'Pets',
    key: 'pets',
  },
  { label: 'Phishing', key: 'phishing' },
  { label: 'Phone', key: 'phone' },
  {
    label: 'PhoneAndroid',
    key: 'phone_android',
  },
  { label: 'PhoneBluetoothSpeaker', key: 'phone_bluetooth_speaker' },
  {
    label: 'PhoneCallback',
    key: 'phone_callback',
  },
  { label: 'PhoneDisabled', key: 'phone_disabled' },
  {
    label: 'PhoneEnabled',
    key: 'phone_enabled',
  },
  { label: 'PhoneForwarded', key: 'phone_forwarded' },
  {
    label: 'PhoneInTalk',
    key: 'phone_in_talk',
  },
  { label: 'PhoneIphone', key: 'phone_iphone' },
  {
    label: 'PhoneLocked',
    key: 'phone_locked',
  },
  { label: 'PhoneMissed', key: 'phone_missed' },
  {
    label: 'PhonePaused',
    key: 'phone_paused',
  },
  { label: 'Phonelink', key: 'phonelink' },
  {
    label: 'PhonelinkErase',
    key: 'phonelink_erase',
  },
  { label: 'PhonelinkLock', key: 'phonelink_lock' },
  {
    label: 'PhonelinkOff',
    key: 'phonelink_off',
  },
  { label: 'PhonelinkRing', key: 'phonelink_ring' },
  {
    label: 'PhonelinkSetup',
    key: 'phonelink_setup',
  },
  { label: 'Photo', key: 'photo' },
  { label: 'PhotoAlbum', key: 'photo_album' },
  {
    label: 'PhotoCamera',
    key: 'photo_camera',
  },
  { label: 'PhotoCameraBack', key: 'photo_camera_back' },
  {
    label: 'PhotoCameraFront',
    key: 'photo_camera_front',
  },
  { label: 'PhotoFilter', key: 'photo_filter' },
  {
    label: 'PhotoLibrary',
    key: 'photo_library',
  },
  { label: 'PhotoSizeSelectActual', key: 'photo_size_select_actual' },
  {
    label: 'PhotoSizeSelectLarge',
    key: 'photo_size_select_large',
  },
  { label: 'PhotoSizeSelectSmall', key: 'photo_size_select_small' },
  {
    label: 'Php',
    key: 'php',
  },
  { label: 'Piano', key: 'piano' },
  { label: 'PianoOff', key: 'piano_off' },
  {
    label: 'PictureAsPdf',
    key: 'picture_as_pdf',
  },
  { label: 'PictureInPicture', key: 'picture_in_picture' },
  {
    label: 'PictureInPictureAlt',
    key: 'picture_in_picture_alt',
  },
  { label: 'PieChart', key: 'pie_chart' },
  {
    label: 'PieChartOutline',
    key: 'pie_chart_outline',
  },
  { label: 'Pin', key: 'pin' },
  { label: 'PinDrop', key: 'pin_drop' },
  {
    label: 'Pinch',
    key: 'pinch',
  },
  { label: 'Pinterest', key: 'pinterest' },
  {
    label: 'PivotTableChart',
    key: 'pivot_table_chart',
  },
  { label: 'Pix', key: 'pix' },
  { label: 'Place', key: 'place' },
  {
    label: 'Plagiarism',
    key: 'plagiarism',
  },
  { label: 'PlayArrow', key: 'play_arrow' },
  {
    label: 'PlayCircle',
    key: 'play_circle',
  },
  { label: 'PlayCircleFilled', key: 'play_circle_filled' },
  {
    label: 'PlayCircleFilledWhite',
    key: 'play_circle_filled_white',
  },
  { label: 'PlayCircleOutline', key: 'play_circle_outline' },
  {
    label: 'PlayDisabled',
    key: 'play_disabled',
  },
  { label: 'PlayForWork', key: 'play_for_work' },
  {
    label: 'PlayLesson',
    key: 'play_lesson',
  },
  { label: 'PlaylistAdd', key: 'playlist_add' },
  {
    label: 'PlaylistAddCheck',
    key: 'playlist_add_check',
  },
  { label: 'PlaylistAddCheckCircle', key: 'playlist_add_check_circle' },
  {
    label: 'PlaylistAddCircle',
    key: 'playlist_add_circle',
  },
  { label: 'PlaylistPlay', key: 'playlist_play' },
  {
    label: 'PlaylistRemove',
    key: 'playlist_remove',
  },
  { label: 'Plumbing', key: 'plumbing' },
  { label: 'PlusOne', key: 'plus_one' },
  {
    label: 'Podcasts',
    key: 'podcasts',
  },
  { label: 'PointOfSale', key: 'point_of_sale' },
  { label: 'Policy', key: 'policy' },
  {
    label: 'Poll',
    key: 'poll',
  },
  { label: 'Polyline', key: 'polyline' },
  { label: 'Pool', key: 'pool' },
  {
    label: 'PortableWifiOff',
    key: 'portable_wifi_off',
  },
  { label: 'Portrait', key: 'portrait' },
  { label: 'PostAdd', key: 'post_add' },
  {
    label: 'Power',
    key: 'power',
  },
  { label: 'PowerInput', key: 'power_input' },
  {
    label: 'PowerOff',
    key: 'power_off',
  },
  { label: 'PowerSettingsNew', key: 'power_settings_new' },
  {
    label: 'PrecisionManufacturing',
    key: 'precision_manufacturing',
  },
  { label: 'PregnantWoman', key: 'pregnant_woman' },
  {
    label: 'PresentToAll',
    key: 'present_to_all',
  },
  { label: 'Preview', key: 'preview' },
  {
    label: 'PriceChange',
    key: 'price_change',
  },
  { label: 'PriceCheck', key: 'price_check' },
  { label: 'Print', key: 'print' },
  {
    label: 'PrintDisabled',
    key: 'print_disabled',
  },
  { label: 'PriorityHigh', key: 'priority_high' },
  {
    label: 'PrivacyTip',
    key: 'privacy_tip',
  },
  { label: 'ProductionQuantityLimits', key: 'production_quantity_limits' },
  {
    label: 'Propane',
    key: 'propane',
  },
  { label: 'PropaneTank', key: 'propane_tank' },
  {
    label: 'Psychology',
    key: 'psychology',
  },
  { label: 'PsychologyAlt', key: 'psychology_alt' },
  {
    label: 'Public',
    key: 'public',
  },
  { label: 'PublicOff', key: 'public_off' },
  {
    label: 'Publish',
    key: 'publish',
  },
  { label: 'PublishedWithChanges', key: 'published_with_changes' },
  {
    label: 'PunchClock',
    key: 'punch_clock',
  },
  { label: 'PushPin', key: 'push_pin' },
  { label: 'QrCode', key: 'qr_code' },
  {
    label: 'QrCode2',
    key: 'qr_code_2',
  },
  { label: 'QrCodeScanner', key: 'qr_code_scanner' },
  {
    label: 'QueryBuilder',
    key: 'query_builder',
  },
  { label: 'QueryStats', key: 'query_stats' },
  {
    label: 'QuestionAnswer',
    key: 'question_answer',
  },
  { label: 'QuestionMark', key: 'question_mark' },
  { label: 'Queue', key: 'queue' },
  {
    label: 'QueueMusic',
    key: 'queue_music',
  },
  { label: 'QueuePlayNext', key: 'queue_play_next' },
  {
    label: 'Quickreply',
    key: 'quickreply',
  },
  { label: 'Quiz', key: 'quiz' },
  { label: 'RMobiledata', key: 'r_mobiledata' },
  {
    label: 'Radar',
    key: 'radar',
  },
  { label: 'Radio', key: 'radio' },
  {
    label: 'RadioButtonChecked',
    key: 'radio_button_checked',
  },
  { label: 'RadioButtonUnchecked', key: 'radio_button_unchecked' },
  {
    label: 'RailwayAlert',
    key: 'railway_alert',
  },
  { label: 'RamenDining', key: 'ramen_dining' },
  {
    label: 'RampLeft',
    key: 'ramp_left',
  },
  { label: 'RampRight', key: 'ramp_right' },
  {
    label: 'RateReview',
    key: 'rate_review',
  },
  { label: 'RawOff', key: 'raw_off' },
  { label: 'RawOn', key: 'raw_on' },
  {
    label: 'ReadMore',
    key: 'read_more',
  },
  { label: 'Receipt', key: 'receipt' },
  {
    label: 'ReceiptLong',
    key: 'receipt_long',
  },
  { label: 'RecentActors', key: 'recent_actors' },
  {
    label: 'Recommend',
    key: 'recommend',
  },
  { label: 'RecordVoiceOver', key: 'record_voice_over' },
  {
    label: 'Rectangle',
    key: 'rectangle',
  },
  { label: 'Reddit', key: 'reddit' },
  { label: 'Redeem', key: 'redeem' },
  {
    label: 'Redo',
    key: 'redo',
  },
  { label: 'ReduceCapacity', key: 'reduce_capacity' },
  {
    label: 'Refresh',
    key: 'refresh',
  },
  { label: 'RememberMe', key: 'remember_me' },
  { label: 'Remove', key: 'remove' },
  {
    label: 'RemoveCircle',
    key: 'remove_circle',
  },
  { label: 'RemoveCircleOutline', key: 'remove_circle_outline' },
  {
    label: 'RemoveDone',
    key: 'remove_done',
  },
  { label: 'RemoveFromQueue', key: 'remove_from_queue' },
  {
    label: 'RemoveModerator',
    key: 'remove_moderator',
  },
  { label: 'RemoveRedEye', key: 'remove_red_eye' },
  {
    label: 'RemoveRoad',
    key: 'remove_road',
  },
  { label: 'RemoveShoppingCart', key: 'remove_shopping_cart' },
  {
    label: 'Reorder',
    key: 'reorder',
  },
  { label: 'Repartition', key: 'repartition' },
  { label: 'Repeat', key: 'repeat' },
  {
    label: 'RepeatOn',
    key: 'repeat_on',
  },
  { label: 'RepeatOne', key: 'repeat_one' },
  {
    label: 'RepeatOneOn',
    key: 'repeat_one_on',
  },
  { label: 'Replay', key: 'replay' },
  { label: 'Replay10', key: 'replay_10' },
  {
    label: 'Replay30',
    key: 'replay_30',
  },
  { label: 'Replay5', key: 'replay_5' },
  {
    label: 'ReplayCircleFilled',
    key: 'replay_circle_filled',
  },
  { label: 'Reply', key: 'reply' },
  { label: 'ReplyAll', key: 'reply_all' },
  {
    label: 'Report',
    key: 'report',
  },
  { label: 'ReportGmailerrorred', key: 'report_gmailerrorred' },
  {
    label: 'ReportOff',
    key: 'report_off',
  },
  { label: 'ReportProblem', key: 'report_problem' },
  {
    label: 'RequestPage',
    key: 'request_page',
  },
  { label: 'RequestQuote', key: 'request_quote' },
  {
    label: 'ResetTv',
    key: 'reset_tv',
  },
  { label: 'RestartAlt', key: 'restart_alt' },
  {
    label: 'Restaurant',
    key: 'restaurant',
  },
  { label: 'RestaurantMenu', key: 'restaurant_menu' },
  {
    label: 'Restore',
    key: 'restore',
  },
  { label: 'RestoreFromTrash', key: 'restore_from_trash' },
  {
    label: 'RestorePage',
    key: 'restore_page',
  },
  { label: 'Reviews', key: 'reviews' },
  { label: 'RiceBowl', key: 'rice_bowl' },
  {
    label: 'RingVolume',
    key: 'ring_volume',
  },
  { label: 'Rocket', key: 'rocket' },
  {
    label: 'RocketLaunch',
    key: 'rocket_launch',
  },
  { label: 'RollerShades', key: 'roller_shades' },
  {
    label: 'RollerShadesClosed',
    key: 'roller_shades_closed',
  },
  { label: 'RollerSkating', key: 'roller_skating' },
  { label: 'Roofing', key: 'roofing' },
  {
    label: 'Room',
    key: 'room',
  },
  { label: 'RoomPreferences', key: 'room_preferences' },
  {
    label: 'RoomService',
    key: 'room_service',
  },
  { label: 'Rotate90DegreesCcw', key: 'rotate_90_degrees_ccw' },
  {
    label: 'Rotate90DegreesCw',
    key: 'rotate_90_degrees_cw',
  },
  { label: 'RotateLeft', key: 'rotate_left' },
  {
    label: 'RotateRight',
    key: 'rotate_right',
  },
  { label: 'RoundaboutLeft', key: 'roundabout_left' },
  {
    label: 'RoundaboutRight',
    key: 'roundabout_right',
  },
  { label: 'Route', key: 'route' },
  { label: 'Router', key: 'router' },
  {
    label: 'Rowing',
    key: 'rowing',
  },
  { label: 'RssFeed', key: 'rss_feed' },
  { label: 'Rsvp', key: 'rsvp' },
  {
    label: 'Rtt',
    key: 'rtt',
  },
  { label: 'Rule', key: 'rule' },
  { label: 'RuleFolder', key: 'rule_folder' },
  {
    label: 'RunCircle',
    key: 'run_circle',
  },
  { label: 'RunningWithErrors', key: 'running_with_errors' },
  {
    label: 'RvHookup',
    key: 'rv_hookup',
  },
  { label: 'SafetyCheck', key: 'safety_check' },
  {
    label: 'SafetyDivider',
    key: 'safety_divider',
  },
  { label: 'Sailing', key: 'sailing' },
  { label: 'Sanitizer', key: 'sanitizer' },
  {
    label: 'Satellite',
    key: 'satellite',
  },
  { label: 'SatelliteAlt', key: 'satellite_alt' },
  { label: 'Save', key: 'save' },
  {
    label: 'SaveAlt',
    key: 'save_alt',
  },
  { label: 'SaveAs', key: 'save_as' },
  { label: 'SavedSearch', key: 'saved_search' },
  {
    label: 'Savings',
    key: 'savings',
  },
  { label: 'Scale', key: 'scale' },
  { label: 'Scanner', key: 'scanner' },
  {
    label: 'ScatterPlot',
    key: 'scatter_plot',
  },
  { label: 'Schedule', key: 'schedule' },
  {
    label: 'ScheduleSend',
    key: 'schedule_send',
  },
  { label: 'Schema', key: 'schema' },
  { label: 'School', key: 'school' },
  {
    label: 'Science',
    key: 'science',
  },
  { label: 'Score', key: 'score' },
  {
    label: 'Scoreboard',
    key: 'scoreboard',
  },
  { label: 'ScreenLockLandscape', key: 'screen_lock_landscape' },
  {
    label: 'ScreenLockPortrait',
    key: 'screen_lock_portrait',
  },
  { label: 'ScreenLockRotation', key: 'screen_lock_rotation' },
  {
    label: 'ScreenRotation',
    key: 'screen_rotation',
  },
  { label: 'ScreenRotationAlt', key: 'screen_rotation_alt' },
  {
    label: 'ScreenSearchDesktop',
    key: 'screen_search_desktop',
  },
  { label: 'ScreenShare', key: 'screen_share' },
  {
    label: 'Screenshot',
    key: 'screenshot',
  },
  { label: 'ScreenshotMonitor', key: 'screenshot_monitor' },
  {
    label: 'ScubaDiving',
    key: 'scuba_diving',
  },
  { label: 'Sd', key: 'sd' },
  { label: 'SdCard', key: 'sd_card' },
  {
    label: 'SdCardAlert',
    key: 'sd_card_alert',
  },
  { label: 'SdStorage', key: 'sd_storage' },
  { label: 'Search', key: 'search' },
  {
    label: 'SearchOff',
    key: 'search_off',
  },
  { label: 'Security', key: 'security' },
  {
    label: 'SecurityUpdate',
    key: 'security_update',
  },
  { label: 'SecurityUpdateGood', key: 'security_update_good' },
  {
    label: 'SecurityUpdateWarning',
    key: 'security_update_warning',
  },
  { label: 'Segment', key: 'segment' },
  {
    label: 'SelectAll',
    key: 'select_all',
  },
  { label: 'SelfImprovement', key: 'self_improvement' },
  { label: 'Sell', key: 'sell' },
  {
    label: 'Send',
    key: 'send',
  },
  { label: 'SendAndArchive', key: 'send_and_archive' },
  {
    label: 'SendTimeExtension',
    key: 'send_time_extension',
  },
  { label: 'SendToMobile', key: 'send_to_mobile' },
  {
    label: 'SensorDoor',
    key: 'sensor_door',
  },
  { label: 'SensorOccupied', key: 'sensor_occupied' },
  {
    label: 'SensorWindow',
    key: 'sensor_window',
  },
  { label: 'Sensors', key: 'sensors' },
  {
    label: 'SensorsOff',
    key: 'sensors_off',
  },
  { label: 'SentimentDissatisfied', key: 'sentiment_dissatisfied' },
  {
    label: 'SentimentNeutral',
    key: 'sentiment_neutral',
  },
  { label: 'SentimentSatisfied', key: 'sentiment_satisfied' },
  {
    label: 'SentimentSatisfiedAlt',
    key: 'sentiment_satisfied_alt',
  },
  {
    label: 'SentimentVeryDissatisfied',
    key: 'sentiment_very_dissatisfied',
  },
  { label: 'SentimentVerySatisfied', key: 'sentiment_very_satisfied' },
  {
    label: 'SetMeal',
    key: 'set_meal',
  },
  { label: 'Settings', key: 'settings' },
  {
    label: 'SettingsAccessibility',
    key: 'settings_accessibility',
  },
  { label: 'SettingsApplications', key: 'settings_applications' },
  {
    label: 'SettingsBackupRestore',
    key: 'settings_backup_restore',
  },
  { label: 'SettingsBluetooth', key: 'settings_bluetooth' },
  {
    label: 'SettingsBrightness',
    key: 'settings_brightness',
  },
  { label: 'SettingsCell', key: 'settings_cell' },
  {
    label: 'SettingsEthernet',
    key: 'settings_ethernet',
  },
  { label: 'SettingsInputAntenna', key: 'settings_input_antenna' },
  {
    label: 'SettingsInputComponent',
    key: 'settings_input_component',
  },
  { label: 'SettingsInputComposite', key: 'settings_input_composite' },
  {
    label: 'SettingsInputHdmi',
    key: 'settings_input_hdmi',
  },
  { label: 'SettingsInputSvideo', key: 'settings_input_svideo' },
  {
    label: 'SettingsOverscan',
    key: 'settings_overscan',
  },
  { label: 'SettingsPhone', key: 'settings_phone' },
  {
    label: 'SettingsPower',
    key: 'settings_power',
  },
  { label: 'SettingsRemote', key: 'settings_remote' },
  {
    label: 'SettingsSuggest',
    key: 'settings_suggest',
  },
  { label: 'SettingsSystemDaydream', key: 'settings_system_daydream' },
  {
    label: 'SettingsVoice',
    key: 'settings_voice',
  },
  { label: 'SevenK', key: 'seven_k' },
  { label: 'SevenKPlus', key: 'seven_k_plus' },
  {
    label: 'SevenMp',
    key: 'seven_mp',
  },
  { label: 'SeventeenMp', key: 'seventeen_mp' },
  {
    label: 'SevereCold',
    key: 'severe_cold',
  },
  { label: 'ShapeLine', key: 'shape_line' },
  { label: 'Share', key: 'share' },
  {
    label: 'ShareLocation',
    key: 'share_location',
  },
  { label: 'Shield', key: 'shield' },
  { label: 'ShieldMoon', key: 'shield_moon' },
  {
    label: 'Shop',
    key: 'shop',
  },
  { label: 'Shop2', key: 'shop_2' },
  { label: 'ShopTwo', key: 'shop_two' },
  {
    label: 'ShoppingBag',
    key: 'shopping_bag',
  },
  { label: 'ShoppingBasket', key: 'shopping_basket' },
  {
    label: 'ShoppingCart',
    key: 'shopping_cart',
  },
  { label: 'ShoppingCartCheckout', key: 'shopping_cart_checkout' },
  {
    label: 'ShortText',
    key: 'short_text',
  },
  { label: 'Shortcut', key: 'shortcut' },
  { label: 'ShowChart', key: 'show_chart' },
  {
    label: 'Shower',
    key: 'shower',
  },
  { label: 'Shuffle', key: 'shuffle' },
  { label: 'ShuffleOn', key: 'shuffle_on' },
  {
    label: 'ShutterSpeed',
    key: 'shutter_speed',
  },
  { label: 'Sick', key: 'sick' },
  {
    label: 'SignLanguage',
    key: 'sign_language',
  },
  { label: 'SignalCellular0Bar', key: 'signal_cellular_0_bar' },
  {
    label: 'SignalCellular1Bar',
    key: 'signal_cellular_1_bar',
  },
  { label: 'SignalCellular2Bar', key: 'signal_cellular_2_bar' },
  {
    label: 'SignalCellular3Bar',
    key: 'signal_cellular_3_bar',
  },
  { label: 'SignalCellular4Bar', key: 'signal_cellular_4_bar' },
  {
    label: 'SignalCellularAlt',
    key: 'signal_cellular_alt',
  },
  { label: 'SignalCellularAlt1Bar', key: 'signal_cellular_alt_1_bar' },
  {
    label: 'SignalCellularAlt2Bar',
    key: 'signal_cellular_alt_2_bar',
  },
  {
    label: 'SignalCellularConnectedNoInternet0Bar',
    key: 'signal_cellular_connected_no_internet_0_bar',
  },
  {
    label: 'SignalCellularConnectedNoInternet1Bar',
    key: 'signal_cellular_connected_no_internet_1_bar',
  },
  {
    label: 'SignalCellularConnectedNoInternet2Bar',
    key: 'signal_cellular_connected_no_internet_2_bar',
  },
  {
    label: 'SignalCellularConnectedNoInternet3Bar',
    key: 'signal_cellular_connected_no_internet_3_bar',
  },
  {
    label: 'SignalCellularConnectedNoInternet4Bar',
    key: 'signal_cellular_connected_no_internet_4_bar',
  },
  { label: 'SignalCellularNoSim', key: 'signal_cellular_no_sim' },
  {
    label: 'SignalCellularNodata',
    key: 'signal_cellular_nodata',
  },
  { label: 'SignalCellularNull', key: 'signal_cellular_null' },
  {
    label: 'SignalCellularOff',
    key: 'signal_cellular_off',
  },
  { label: 'SignalWifi0Bar', key: 'signal_wifi_0_bar' },
  {
    label: 'SignalWifi1Bar',
    key: 'signal_wifi_1_bar',
  },
  { label: 'SignalWifi1BarLock', key: 'signal_wifi_1_bar_lock' },
  {
    label: 'SignalWifi2Bar',
    key: 'signal_wifi_2_bar',
  },
  { label: 'SignalWifi2BarLock', key: 'signal_wifi_2_bar_lock' },
  {
    label: 'SignalWifi3Bar',
    key: 'signal_wifi_3_bar',
  },
  { label: 'SignalWifi3BarLock', key: 'signal_wifi_3_bar_lock' },
  {
    label: 'SignalWifi4Bar',
    key: 'signal_wifi_4_bar',
  },
  { label: 'SignalWifi4BarLock', key: 'signal_wifi_4_bar_lock' },
  {
    label: 'SignalWifiBad',
    key: 'signal_wifi_bad',
  },
  {
    label: 'SignalWifiConnectedNoInternet4',
    key: 'signal_wifi_connected_no_internet_4',
  },
  { label: 'SignalWifiOff', key: 'signal_wifi_off' },
  {
    label: 'SignalWifiStatusbar4Bar',
    key: 'signal_wifi_statusbar_4_bar',
  },
  {
    label: 'SignalWifiStatusbarConnectedNoInternet4',
    key: 'signal_wifi_statusbar_connected_no_internet_4',
  },
  { label: 'SignalWifiStatusbarNull', key: 'signal_wifi_statusbar_null' },
  {
    label: 'Signpost',
    key: 'signpost',
  },
  { label: 'SimCard', key: 'sim_card' },
  {
    label: 'SimCardAlert',
    key: 'sim_card_alert',
  },
  { label: 'SimCardDownload', key: 'sim_card_download' },
  {
    label: 'SingleBed',
    key: 'single_bed',
  },
  { label: 'Sip', key: 'sip' },
  { label: 'SixK', key: 'six_k' },
  {
    label: 'SixKPlus',
    key: 'six_k_plus',
  },
  { label: 'SixMp', key: 'six_mp' },
  { label: 'SixteenMp', key: 'sixteen_mp' },
  {
    label: 'SixtyFps',
    key: 'sixty_fps',
  },
  { label: 'SixtyFpsSelect', key: 'sixty_fps_select' },
  {
    label: 'Skateboarding',
    key: 'skateboarding',
  },
  { label: 'SkipNext', key: 'skip_next' },
  {
    label: 'SkipPrevious',
    key: 'skip_previous',
  },
  { label: 'Sledding', key: 'sledding' },
  {
    label: 'Slideshow',
    key: 'slideshow',
  },
  { label: 'SlowMotionVideo', key: 'slow_motion_video' },
  {
    label: 'SmartButton',
    key: 'smart_button',
  },
  { label: 'SmartDisplay', key: 'smart_display' },
  {
    label: 'SmartScreen',
    key: 'smart_screen',
  },
  { label: 'SmartToy', key: 'smart_toy' },
  {
    label: 'Smartphone',
    key: 'smartphone',
  },
  { label: 'SmokeFree', key: 'smoke_free' },
  {
    label: 'SmokingRooms',
    key: 'smoking_rooms',
  },
  { label: 'Sms', key: 'sms' },
  { label: 'SmsFailed', key: 'sms_failed' },
  {
    label: 'SnippetFolder',
    key: 'snippet_folder',
  },
  { label: 'Snooze', key: 'snooze' },
  {
    label: 'Snowboarding',
    key: 'snowboarding',
  },
  { label: 'Snowmobile', key: 'snowmobile' },
  {
    label: 'Snowshoeing',
    key: 'snowshoeing',
  },
  { label: 'Soap', key: 'soap' },
  {
    label: 'SocialDistance',
    key: 'social_distance',
  },
  { label: 'SolarPower', key: 'solar_power' },
  { label: 'Sort', key: 'sort' },
  {
    label: 'SortByAlpha',
    key: 'sort_by_alpha',
  },
  { label: 'Sos', key: 'sos' },
  { label: 'SoupKitchen', key: 'soup_kitchen' },
  {
    label: 'Source',
    key: 'source',
  },
  { label: 'South', key: 'south' },
  { label: 'SouthAmerica', key: 'south_america' },
  {
    label: 'SouthEast',
    key: 'south_east',
  },
  { label: 'SouthWest', key: 'south_west' },
  { label: 'Spa', key: 'spa' },
  {
    label: 'SpaceBar',
    key: 'space_bar',
  },
  { label: 'SpatialAudio', key: 'spatial_audio' },
  {
    label: 'SpatialAudioOff',
    key: 'spatial_audio_off',
  },
  { label: 'SpatialTracking', key: 'spatial_tracking' },
  {
    label: 'Speaker',
    key: 'speaker',
  },
  { label: 'SpeakerGroup', key: 'speaker_group' },
  {
    label: 'SpeakerNotes',
    key: 'speaker_notes',
  },
  { label: 'SpeakerNotesOff', key: 'speaker_notes_off' },
  {
    label: 'SpeakerPhone',
    key: 'speaker_phone',
  },
  { label: 'Speed', key: 'speed' },
  { label: 'Spellcheck', key: 'spellcheck' },
  {
    label: 'Splitscreen',
    key: 'splitscreen',
  },
  { label: 'Spoke', key: 'spoke' },
  { label: 'Sports', key: 'sports' },
  {
    label: 'SportsBar',
    key: 'sports_bar',
  },
  { label: 'SportsBaseball', key: 'sports_baseball' },
  {
    label: 'SportsBasketball',
    key: 'sports_basketball',
  },
  { label: 'SportsCricket', key: 'sports_cricket' },
  {
    label: 'SportsEsports',
    key: 'sports_esports',
  },
  { label: 'SportsFootball', key: 'sports_football' },
  {
    label: 'SportsGolf',
    key: 'sports_golf',
  },
  { label: 'SportsGymnastics', key: 'sports_gymnastics' },
  {
    label: 'SportsHandball',
    key: 'sports_handball',
  },
  { label: 'SportsHockey', key: 'sports_hockey' },
  {
    label: 'SportsKabaddi',
    key: 'sports_kabaddi',
  },
  { label: 'SportsMartialArts', key: 'sports_martial_arts' },
  {
    label: 'SportsMma',
    key: 'sports_mma',
  },
  { label: 'SportsMotorsports', key: 'sports_motorsports' },
  {
    label: 'SportsRugby',
    key: 'sports_rugby',
  },
  { label: 'SportsScore', key: 'sports_score' },
  {
    label: 'SportsSoccer',
    key: 'sports_soccer',
  },
  { label: 'SportsTennis', key: 'sports_tennis' },
  {
    label: 'SportsVolleyball',
    key: 'sports_volleyball',
  },
  { label: 'Square', key: 'square' },
  { label: 'SquareFoot', key: 'square_foot' },
  {
    label: 'SsidChart',
    key: 'ssid_chart',
  },
  { label: 'StackedBarChart', key: 'stacked_bar_chart' },
  {
    label: 'StackedLineChart',
    key: 'stacked_line_chart',
  },
  { label: 'Stadium', key: 'stadium' },
  { label: 'Stairs', key: 'stairs' },
  {
    label: 'Star',
    key: 'star',
  },
  { label: 'StarBorder', key: 'star_border' },
  {
    label: 'StarBorderPurple500',
    key: 'star_border_purple_500',
  },
  { label: 'StarHalf', key: 'star_half' },
  {
    label: 'StarOutline',
    key: 'star_outline',
  },
  { label: 'StarPurple500', key: 'star_purple_500' },
  {
    label: 'StarRate',
    key: 'star_rate',
  },
  { label: 'Stars', key: 'stars' },
  { label: 'Start', key: 'start' },
  {
    label: 'StayCurrentLandscape',
    key: 'stay_current_landscape',
  },
  { label: 'StayCurrentPortrait', key: 'stay_current_portrait' },
  {
    label: 'StayPrimaryLandscape',
    key: 'stay_primary_landscape',
  },
  { label: 'StayPrimaryPortrait', key: 'stay_primary_portrait' },
  {
    label: 'StickyNote2',
    key: 'sticky_note_2',
  },
  { label: 'Stop', key: 'stop' },
  { label: 'StopCircle', key: 'stop_circle' },
  {
    label: 'StopScreenShare',
    key: 'stop_screen_share',
  },
  { label: 'Storage', key: 'storage' },
  { label: 'Store', key: 'store' },
  {
    label: 'StoreMallDirectory',
    key: 'store_mall_directory',
  },
  { label: 'Storefront', key: 'storefront' },
  { label: 'Storm', key: 'storm' },
  {
    label: 'Straight',
    key: 'straight',
  },
  { label: 'Straighten', key: 'straighten' },
  { label: 'Stream', key: 'stream' },
  {
    label: 'Streetview',
    key: 'streetview',
  },
  { label: 'StrikethroughS', key: 'strikethrough_s' },
  {
    label: 'Stroller',
    key: 'stroller',
  },
  { label: 'Style', key: 'style' },
  {
    label: 'SubdirectoryArrowLeft',
    key: 'subdirectory_arrow_left',
  },
  { label: 'SubdirectoryArrowRight', key: 'subdirectory_arrow_right' },
  {
    label: 'Subject',
    key: 'subject',
  },
  { label: 'Subscript', key: 'subscript' },
  {
    label: 'Subscriptions',
    key: 'subscriptions',
  },
  { label: 'Subtitles', key: 'subtitles' },
  {
    label: 'SubtitlesOff',
    key: 'subtitles_off',
  },
  { label: 'Subway', key: 'subway' },
  { label: 'Summarize', key: 'summarize' },
  {
    label: 'Superscript',
    key: 'superscript',
  },
  { label: 'SupervisedUserCircle', key: 'supervised_user_circle' },
  {
    label: 'SupervisorAccount',
    key: 'supervisor_account',
  },
  { label: 'Support', key: 'support' },
  {
    label: 'SupportAgent',
    key: 'support_agent',
  },
  { label: 'Surfing', key: 'surfing' },
  {
    label: 'SurroundSound',
    key: 'surround_sound',
  },
  { label: 'SwapCalls', key: 'swap_calls' },
  {
    label: 'SwapHoriz',
    key: 'swap_horiz',
  },
  { label: 'SwapHorizontalCircle', key: 'swap_horizontal_circle' },
  {
    label: 'SwapVert',
    key: 'swap_vert',
  },
  { label: 'SwapVerticalCircle', key: 'swap_vertical_circle' },
  {
    label: 'Swipe',
    key: 'swipe',
  },
  { label: 'SwipeDown', key: 'swipe_down' },
  {
    label: 'SwipeDownAlt',
    key: 'swipe_down_alt',
  },
  { label: 'SwipeLeft', key: 'swipe_left' },
  {
    label: 'SwipeLeftAlt',
    key: 'swipe_left_alt',
  },
  { label: 'SwipeRight', key: 'swipe_right' },
  {
    label: 'SwipeRightAlt',
    key: 'swipe_right_alt',
  },
  { label: 'SwipeUp', key: 'swipe_up' },
  {
    label: 'SwipeUpAlt',
    key: 'swipe_up_alt',
  },
  { label: 'SwipeVertical', key: 'swipe_vertical' },
  {
    label: 'SwitchAccessShortcut',
    key: 'switch_access_shortcut',
  },
  { label: 'SwitchAccessShortcutAdd', key: 'switch_access_shortcut_add' },
  {
    label: 'SwitchAccount',
    key: 'switch_account',
  },
  { label: 'SwitchCamera', key: 'switch_camera' },
  {
    label: 'SwitchLeft',
    key: 'switch_left',
  },
  { label: 'SwitchRight', key: 'switch_right' },
  {
    label: 'SwitchVideo',
    key: 'switch_video',
  },
  { label: 'Synagogue', key: 'synagogue' },
  { label: 'Sync', key: 'sync' },
  {
    label: 'SyncAlt',
    key: 'sync_alt',
  },
  { label: 'SyncDisabled', key: 'sync_disabled' },
  {
    label: 'SyncLock',
    key: 'sync_lock',
  },
  { label: 'SyncProblem', key: 'sync_problem' },
  {
    label: 'SystemSecurityUpdate',
    key: 'system_security_update',
  },
  {
    label: 'SystemSecurityUpdateGood',
    key: 'system_security_update_good',
  },
  {
    label: 'SystemSecurityUpdateWarning',
    key: 'system_security_update_warning',
  },
  {
    label: 'SystemUpdate',
    key: 'system_update',
  },
  { label: 'SystemUpdateAlt', key: 'system_update_alt' },
  {
    label: 'Tab',
    key: 'tab',
  },
  { label: 'TabUnselected', key: 'tab_unselected' },
  {
    label: 'TableBar',
    key: 'table_bar',
  },
  { label: 'TableChart', key: 'table_chart' },
  {
    label: 'TableRestaurant',
    key: 'table_restaurant',
  },
  { label: 'TableRows', key: 'table_rows' },
  { label: 'TableView', key: 'table_view' },
  {
    label: 'Tablet',
    key: 'tablet',
  },
  { label: 'TabletAndroid', key: 'tablet_android' },
  {
    label: 'TabletMac',
    key: 'tablet_mac',
  },
  { label: 'Tag', key: 'tag' },
  { label: 'TagFaces', key: 'tag_faces' },
  {
    label: 'TakeoutDining',
    key: 'takeout_dining',
  },
  { label: 'TapAndPlay', key: 'tap_and_play' },
  { label: 'Tapas', key: 'tapas' },
  {
    label: 'Task',
    key: 'task',
  },
  { label: 'TaskAlt', key: 'task_alt' },
  { label: 'TaxiAlert', key: 'taxi_alert' },
  {
    label: 'Telegram',
    key: 'telegram',
  },
  { label: 'TempleBuddhist', key: 'temple_buddhist' },
  {
    label: 'TempleHindu',
    key: 'temple_hindu',
  },
  { label: 'TenMp', key: 'ten_mp' },
  { label: 'Terminal', key: 'terminal' },
  {
    label: 'Terrain',
    key: 'terrain',
  },
  { label: 'TextDecrease', key: 'text_decrease' },
  {
    label: 'TextFields',
    key: 'text_fields',
  },
  { label: 'TextFormat', key: 'text_format' },
  {
    label: 'TextIncrease',
    key: 'text_increase',
  },
  { label: 'TextRotateUp', key: 'text_rotate_up' },
  {
    label: 'TextRotateVertical',
    key: 'text_rotate_vertical',
  },
  { label: 'TextRotationAngledown', key: 'text_rotation_angledown' },
  {
    label: 'TextRotationAngleup',
    key: 'text_rotation_angleup',
  },
  { label: 'TextRotationDown', key: 'text_rotation_down' },
  {
    label: 'TextRotationNone',
    key: 'text_rotation_none',
  },
  { label: 'TextSnippet', key: 'text_snippet' },
  { label: 'Textsms', key: 'textsms' },
  {
    label: 'Texture',
    key: 'texture',
  },
  { label: 'TheaterComedy', key: 'theater_comedy' },
  {
    label: 'Theaters',
    key: 'theaters',
  },
  { label: 'Thermostat', key: 'thermostat' },
  {
    label: 'ThermostatAuto',
    key: 'thermostat_auto',
  },
  { label: 'ThirteenMp', key: 'thirteen_mp' },
  {
    label: 'ThirtyFps',
    key: 'thirty_fps',
  },
  { label: 'ThirtyFpsSelect', key: 'thirty_fps_select' },
  {
    label: 'ThreeDRotation',
    key: 'three_d_rotation',
  },
  { label: 'ThreeGMobiledata', key: 'three_g_mobiledata' },
  {
    label: 'ThreeK',
    key: 'three_k',
  },
  { label: 'ThreeKPlus', key: 'three_k_plus' },
  { label: 'ThreeMp', key: 'three_mp' },
  {
    label: 'ThreeP',
    key: 'three_p',
  },
  { label: 'ThreeSixty', key: 'three_sixty' },
  {
    label: 'ThumbDown',
    key: 'thumb_down',
  },
  { label: 'ThumbDownAlt', key: 'thumb_down_alt' },
  {
    label: 'ThumbDownOffAlt',
    key: 'thumb_down_off_alt',
  },
  { label: 'ThumbUp', key: 'thumb_up' },
  {
    label: 'ThumbUpAlt',
    key: 'thumb_up_alt',
  },
  { label: 'ThumbUpOffAlt', key: 'thumb_up_off_alt' },
  {
    label: 'ThumbsUpDown',
    key: 'thumbs_up_down',
  },
  { label: 'Thunderstorm', key: 'thunderstorm' },
  {
    label: 'TimeToLeave',
    key: 'time_to_leave',
  },
  { label: 'Timelapse', key: 'timelapse' },
  { label: 'Timeline', key: 'timeline' },
  {
    label: 'Timer',
    key: 'timer',
  },
  { label: 'Timer10', key: 'timer_10' },
  {
    label: 'Timer10Select',
    key: 'timer_10_select',
  },
  { label: 'Timer3', key: 'timer_3' },
  {
    label: 'Timer3Select',
    key: 'timer_3_select',
  },
  { label: 'TimerOff', key: 'timer_off' },
  {
    label: 'TimesOneMobiledata',
    key: 'times_one_mobiledata',
  },
  { label: 'TipsAndUpdates', key: 'tips_and_updates' },
  {
    label: 'TireRepair',
    key: 'tire_repair',
  },
  { label: 'Title', key: 'title' },
  { label: 'Toc', key: 'toc' },
  {
    label: 'Today',
    key: 'today',
  },
  { label: 'ToggleOff', key: 'toggle_off' },
  { label: 'ToggleOn', key: 'toggle_on' },
  {
    label: 'Token',
    key: 'token',
  },
  { label: 'Toll', key: 'toll' },
  { label: 'Tonality', key: 'tonality' },
  {
    label: 'Topic',
    key: 'topic',
  },
  { label: 'Tornado', key: 'tornado' },
  { label: 'TouchApp', key: 'touch_app' },
  {
    label: 'Tour',
    key: 'tour',
  },
  { label: 'Toys', key: 'toys' },
  { label: 'TrackChanges', key: 'track_changes' },
  {
    label: 'Traffic',
    key: 'traffic',
  },
  { label: 'Train', key: 'train' },
  { label: 'Tram', key: 'tram' },
  {
    label: 'Transcribe',
    key: 'transcribe',
  },
  { label: 'TransferWithinAStation', key: 'transfer_within_a_station' },
  {
    label: 'Transform',
    key: 'transform',
  },
  { label: 'Transgender', key: 'transgender' },
  {
    label: 'TransitEnterexit',
    key: 'transit_enterexit',
  },
  { label: 'Translate', key: 'translate' },
  {
    label: 'TravelExplore',
    key: 'travel_explore',
  },
  { label: 'TrendingDown', key: 'trending_down' },
  {
    label: 'TrendingFlat',
    key: 'trending_flat',
  },
  { label: 'TrendingUp', key: 'trending_up' },
  {
    label: 'TripOrigin',
    key: 'trip_origin',
  },
  { label: 'Troubleshoot', key: 'troubleshoot' },
  { label: 'Try', key: 'try' },
  {
    label: 'Tsunami',
    key: 'tsunami',
  },
  { label: 'Tty', key: 'tty' },
  { label: 'Tune', key: 'tune' },
  {
    label: 'Tungsten',
    key: 'tungsten',
  },
  { label: 'TurnLeft', key: 'turn_left' },
  {
    label: 'TurnRight',
    key: 'turn_right',
  },
  { label: 'TurnSlightLeft', key: 'turn_slight_left' },
  {
    label: 'TurnSlightRight',
    key: 'turn_slight_right',
  },
  { label: 'TurnedIn', key: 'turned_in' },
  { label: 'TurnedInNot', key: 'turned_in_not' },
  {
    label: 'Tv',
    key: 'tv',
  },
  { label: 'TvOff', key: 'tv_off' },
  { label: 'TwelveMp', key: 'twelve_mp' },
  {
    label: 'TwentyFourMp',
    key: 'twenty_four_mp',
  },
  { label: 'TwentyOneMp', key: 'twenty_one_mp' },
  {
    label: 'TwentyThreeMp',
    key: 'twenty_three_mp',
  },
  { label: 'TwentyTwoMp', key: 'twenty_two_mp' },
  {
    label: 'TwentyZeroMp',
    key: 'twenty_zero_mp',
  },
  { label: 'Twitter', key: 'twitter' },
  { label: 'TwoK', key: 'two_k' },
  {
    label: 'TwoKPlus',
    key: 'two_k_plus',
  },
  { label: 'TwoMp', key: 'two_mp' },
  { label: 'TwoWheeler', key: 'two_wheeler' },
  {
    label: 'TypeSpecimen',
    key: 'type_specimen',
  },
  { label: 'UTurnLeft', key: 'u_turn_left' },
  {
    label: 'UTurnRight',
    key: 'u_turn_right',
  },
  { label: 'Umbrella', key: 'umbrella' },
  { label: 'Unarchive', key: 'unarchive' },
  {
    label: 'Undo',
    key: 'undo',
  },
  { label: 'UnfoldLess', key: 'unfold_less' },
  {
    label: 'UnfoldLessDouble',
    key: 'unfold_less_double',
  },
  { label: 'UnfoldMore', key: 'unfold_more' },
  {
    label: 'UnfoldMoreDouble',
    key: 'unfold_more_double',
  },
  { label: 'Unpublished', key: 'unpublished' },
  {
    label: 'Unsubscribe',
    key: 'unsubscribe',
  },
  { label: 'Upcoming', key: 'upcoming' },
  { label: 'Update', key: 'update' },
  {
    label: 'UpdateDisabled',
    key: 'update_disabled',
  },
  { label: 'Upgrade', key: 'upgrade' },
  { label: 'Upload', key: 'upload' },
  {
    label: 'UploadFile',
    key: 'upload_file',
  },
  { label: 'Usb', key: 'usb' },
  { label: 'UsbOff', key: 'usb_off' },
  {
    label: 'Vaccines',
    key: 'vaccines',
  },
  { label: 'VapeFree', key: 'vape_free' },
  {
    label: 'VapingRooms',
    key: 'vaping_rooms',
  },
  { label: 'Verified', key: 'verified' },
  {
    label: 'VerifiedUser',
    key: 'verified_user',
  },
  { label: 'VerticalAlignBottom', key: 'vertical_align_bottom' },
  {
    label: 'VerticalAlignCenter',
    key: 'vertical_align_center',
  },
  { label: 'VerticalAlignTop', key: 'vertical_align_top' },
  {
    label: 'VerticalShades',
    key: 'vertical_shades',
  },
  { label: 'VerticalShadesClosed', key: 'vertical_shades_closed' },
  {
    label: 'VerticalSplit',
    key: 'vertical_split',
  },
  { label: 'Vibration', key: 'vibration' },
  {
    label: 'VideoCall',
    key: 'video_call',
  },
  { label: 'VideoCameraBack', key: 'video_camera_back' },
  {
    label: 'VideoCameraFront',
    key: 'video_camera_front',
  },
  { label: 'VideoChat', key: 'video_chat' },
  {
    label: 'VideoFile',
    key: 'video_file',
  },
  { label: 'VideoLabel', key: 'video_label' },
  {
    label: 'VideoLibrary',
    key: 'video_library',
  },
  { label: 'VideoSettings', key: 'video_settings' },
  {
    label: 'VideoStable',
    key: 'video_stable',
  },
  { label: 'Videocam', key: 'videocam' },
  {
    label: 'VideocamOff',
    key: 'videocam_off',
  },
  { label: 'VideogameAsset', key: 'videogame_asset' },
  {
    label: 'VideogameAssetOff',
    key: 'videogame_asset_off',
  },
  { label: 'ViewAgenda', key: 'view_agenda' },
  {
    label: 'ViewArray',
    key: 'view_array',
  },
  { label: 'ViewCarousel', key: 'view_carousel' },
  {
    label: 'ViewColumn',
    key: 'view_column',
  },
  { label: 'ViewComfy', key: 'view_comfy' },
  {
    label: 'ViewComfyAlt',
    key: 'view_comfy_alt',
  },
  { label: 'ViewCompact', key: 'view_compact' },
  {
    label: 'ViewCompactAlt',
    key: 'view_compact_alt',
  },
  { label: 'ViewCozy', key: 'view_cozy' },
  { label: 'ViewDay', key: 'view_day' },
  {
    label: 'ViewHeadline',
    key: 'view_headline',
  },
  { label: 'ViewInAr', key: 'view_in_ar' },
  {
    label: 'ViewKanban',
    key: 'view_kanban',
  },
  { label: 'ViewList', key: 'view_list' },
  {
    label: 'ViewModule',
    key: 'view_module',
  },
  { label: 'ViewQuilt', key: 'view_quilt' },
  {
    label: 'ViewSidebar',
    key: 'view_sidebar',
  },
  { label: 'ViewStream', key: 'view_stream' },
  {
    label: 'ViewTimeline',
    key: 'view_timeline',
  },
  { label: 'ViewWeek', key: 'view_week' },
  { label: 'Vignette', key: 'vignette' },
  {
    label: 'Villa',
    key: 'villa',
  },
  { label: 'Visibility', key: 'visibility' },
  {
    label: 'VisibilityOff',
    key: 'visibility_off',
  },
  { label: 'VoiceChat', key: 'voice_chat' },
  {
    label: 'VoiceOverOff',
    key: 'voice_over_off',
  },
  { label: 'Voicemail', key: 'voicemail' },
  { label: 'Volcano', key: 'volcano' },
  {
    label: 'VolumeDown',
    key: 'volume_down',
  },
  { label: 'VolumeMute', key: 'volume_mute' },
  {
    label: 'VolumeOff',
    key: 'volume_off',
  },
  { label: 'VolumeUp', key: 'volume_up' },
  {
    label: 'VolunteerActivism',
    key: 'volunteer_activism',
  },
  { label: 'VpnKey', key: 'vpn_key' },
  { label: 'VpnKeyOff', key: 'vpn_key_off' },
  {
    label: 'VpnLock',
    key: 'vpn_lock',
  },
  { label: 'Vrpano', key: 'vrpano' },
  { label: 'Wallet', key: 'wallet' },
  {
    label: 'Wallpaper',
    key: 'wallpaper',
  },
  { label: 'Warehouse', key: 'warehouse' },
  { label: 'Warning', key: 'warning' },
  {
    label: 'WarningAmber',
    key: 'warning_amber',
  },
  { label: 'Wash', key: 'wash' },
  { label: 'Watch', key: 'watch' },
  {
    label: 'WatchLater',
    key: 'watch_later',
  },
  { label: 'WatchOff', key: 'watch_off' },
  { label: 'Water', key: 'water' },
  {
    label: 'WaterDamage',
    key: 'water_damage',
  },
  { label: 'WaterfallChart', key: 'waterfall_chart' },
  { label: 'Waves', key: 'waves' },
  {
    label: 'WbAuto',
    key: 'wb_auto',
  },
  { label: 'WbCloudy', key: 'wb_cloudy' },
  {
    label: 'WbIncandescent',
    key: 'wb_incandescent',
  },
  { label: 'WbIridescent', key: 'wb_iridescent' },
  {
    label: 'WbShade',
    key: 'wb_shade',
  },
  { label: 'WbSunny', key: 'wb_sunny' },
  { label: 'WbTwilight', key: 'wb_twilight' },
  {
    label: 'Wc',
    key: 'wc',
  },
  { label: 'Web', key: 'web' },
  { label: 'WebAsset', key: 'web_asset' },
  {
    label: 'WebAssetOff',
    key: 'web_asset_off',
  },
  { label: 'WebStories', key: 'web_stories' },
  { label: 'Webhook', key: 'webhook' },
  {
    label: 'Weekend',
    key: 'weekend',
  },
  { label: 'West', key: 'west' },
  { label: 'WhatsApp', key: 'whats_app' },
  {
    label: 'Whatshot',
    key: 'whatshot',
  },
  { label: 'WheelchairPickup', key: 'wheelchair_pickup' },
  {
    label: 'WhereToVote',
    key: 'where_to_vote',
  },
  { label: 'Widgets', key: 'widgets' },
  { label: 'WidthFull', key: 'width_full' },
  {
    label: 'WidthNormal',
    key: 'width_normal',
  },
  { label: 'WidthWide', key: 'width_wide' },
  { label: 'Wifi', key: 'wifi' },
  {
    label: 'Wifi1Bar',
    key: 'wifi_1_bar',
  },
  { label: 'Wifi2Bar', key: 'wifi_2_bar' },
  {
    label: 'WifiCalling',
    key: 'wifi_calling',
  },
  { label: 'WifiCalling3', key: 'wifi_calling_3' },
  {
    label: 'WifiChannel',
    key: 'wifi_channel',
  },
  { label: 'WifiFind', key: 'wifi_find' },
  { label: 'WifiLock', key: 'wifi_lock' },
  {
    label: 'WifiOff',
    key: 'wifi_off',
  },
  { label: 'WifiPassword', key: 'wifi_password' },
  {
    label: 'WifiProtectedSetup',
    key: 'wifi_protected_setup',
  },
  { label: 'WifiTethering', key: 'wifi_tethering' },
  {
    label: 'WifiTetheringError',
    key: 'wifi_tethering_error',
  },
  { label: 'WifiTetheringOff', key: 'wifi_tethering_off' },
  {
    label: 'WindPower',
    key: 'wind_power',
  },
  { label: 'Window', key: 'window' },
  { label: 'WineBar', key: 'wine_bar' },
  {
    label: 'Woman',
    key: 'woman',
  },
  { label: 'Woman2', key: 'woman_2' },
  { label: 'Work', key: 'work' },
  {
    label: 'WorkHistory',
    key: 'work_history',
  },
  { label: 'WorkOff', key: 'work_off' },
  {
    label: 'WorkOutline',
    key: 'work_outline',
  },
  { label: 'WorkspacePremium', key: 'workspace_premium' },
  {
    label: 'Workspaces',
    key: 'workspaces',
  },
  { label: 'WrapText', key: 'wrap_text' },
  {
    label: 'WrongLocation',
    key: 'wrong_location',
  },
  { label: 'Wysiwyg', key: 'wysiwyg' },
  { label: 'Yard', key: 'yard' },
  {
    label: 'YouTube',
    key: 'you_tube',
  },
  { label: 'YoutubeSearchedFor', key: 'youtube_searched_for' },
  {
    label: 'ZoomIn',
    key: 'zoom_in',
  },
  { label: 'ZoomInMap', key: 'zoom_in_map' },
  { label: 'ZoomOut', key: 'zoom_out' },
  {
    label: 'ZoomOutMap',
    key: 'zoom_out_map',
  },
]

export const guiThemes = () => {
  return [
    { title: 'Default', value: 'default' },
    { title: 'Blue', value: 'blue' },
    { title: 'Green', value: 'green' },
    { title: 'Orange', value: 'orange' },
    { title: 'Pink', value: 'pink' },
    { title: 'Red', value: 'red' },
  ]
}

export const systemComponents = [
  'API',
  'AssetManager',
  'breadcrumb',
  'BreadcrumbEditor',
  'Carousel',
  'ChangelogPanel',
  'ChartJS',
  'Checklist',
  'Clock',
  'Competence',
  'ConfigManager',
  'CustomComponentEditor',
  'EnvironmentManager',
  'Dashboard',
  'DashboardGenerator',
  'DynForm',
  'EntityConnection',
  'FormDataVersion',
  'FormDesigner',
  'FullCalendarWrapper',
  'Gantt',
  'GuiEditor',
  'HelloWorld',
  'JsonForm',
  'KanbanWrapper',
  'LangSwicher',
  'LanguageTranslator',
  'LeafletWrapper',
  'List',
  'ListFilter',
  'ListView',
  'Localization',
  'MenuEditor',
  'MongoList',
  'Monitoring',
  'Panel',
  'ProcessBuilder',
  'ProcessButton',
  'ProcessButtonList',
  'ProcessListFilter',
  'ProcessListView',
  'ProgressBar',
  'QueryBuilder',
  'QueryList',
  'QueryListFilter',
  'QueryListView',
  'Relationships',
  'Sitemap',
  'StatusLine',
  'TaskBoard',
  'TaskList',
  'TemplateView',
  'TemplateViewer',
  'VueCircle',
  'WorkflowDesigner',
  'WorkflowViewer',
  'Helpy',
  'HelpyDesigner',
  'HelpyForm',
  'ProcessList',
  'ProcessQueueList',
  'ChangePassword',
]

export function paramsTranslate(params, dictionary = {}, url, i, expandedRowParams = {}) {
  const panelId = `${url}:${i}`
  let translated = {}
  params = orderObjToArray(params)
  if (Array.isArray(dictionary)) {
    dictionary.forEach((el) => {
      const coreValue = get(this.$CORE, ['params', el.name])
      if (coreValue) {
        set(translated, el.value, coreValue)
      }
      const rowValue = get(expandedRowParams, el.name)
      if (rowValue) {
        set(translated, [el.value], rowValue)
        set(translated, 'expandedRowParams', { [el.value]: rowValue })
      }
    })
  } else {
    translated = Object.keys(dictionary).reduce((acc, curr) => {
      const coreParamValue = get(this.$CORE, ['params', curr])
      const rowValue = get(expandedRowParams, curr)
      if (curr.includes('#') || curr.includes('DOTO.') || curr.includes('CORE.')) {
        const key = curr.replace(/#/g, '.').replace('DOTO.', '').replace('CORE.', '')
        const coreValue = get(this.$CORE, key, null)
        set(acc, dictionary[curr], coreValue)
      } else if (rowValue) {
        set(acc, dictionary[curr], rowValue)
        set(this.$CORE, ['params', dictionary[curr]], rowValue)
        set(acc, 'expandedRowParams', { [dictionary[curr]]: rowValue })
      } else if (coreParamValue) {
        set(acc, dictionary[curr], coreParamValue)
      } else if (dictionary[curr]) {
        set(acc, dictionary[curr], curr)
      }
      return acc
    }, {})
  }
  const hiddenSearchData = {}

  if (params?.mongoList?.collection === MONGO_COLLECTIONS.FORM_DATA_VERSION) {
    const where = []
    where.push(
      {
        key: 'idForm',
        value: translated.idForm,
      },
      {
        key: 'idMaintable',
        value: translated.idMaintable,
      }
    )
    hiddenSearchData.where = where
  }

  params.hidden = !!params.hidden
  return merge({ panelId }, params, translated, { hiddenSearchData })
}

export function orderObjToArray(params) {
  if (params && params.order && !Array.isArray(params.order)) {
    params.order = [params.order]
  }
  return params
}

let manageAuthUrl = '/api/Authorities/get-func-business-data'
jQuery(document).on('click', '.mutyizoAuth', function (event) {
  event.preventDefault()
  if (jQuery('body').is('.manage-auth')) {
    jQuery(this).html('<span class="fa fa-users fa-2x"></span><div>Autn: On</div>')
  } else {
    jQuery(this).html('<span class="fa fa-users fa-2x"></span><div>Autn: Off</div>')
  }
  jQuery('body').toggleClass('manage-auth')
})

let manageAuthSelector = '.manage-auth a:not([href*="#"]):not([href^="javascript"])[href]:not(.edit-auth-btn)'
jQuery(document).on('click', manageAuthSelector, function (event) {
  event.preventDefault()
})

const qtipRender = (data) => {
  let contexHtml

  contexHtml = `<span class="label ${data.IS_TECHNICAL ? 'label-success' : 'label-default'}">Technical</span>`
  contexHtml += `<span class="label ${data.IS_PUBLIC ? 'label-success' : 'label-default'}">Public</span>`
  contexHtml += `<div class="card">
        <div class="card-block">
            <h4 class="card-title">Groups</h4>
        </div>
        <div id="w16164836764858" class="list-group list-group-flush">`
  if (data && data.GROUPS && Array.isArray(data.GROUPS)) {
    data.GROUPS.forEach((e) => {
      contexHtml += `<div class="list-group-item" data-key="${e}">${e}</div>`
    })
  }
  contexHtml += `</div></div>`
  if (data && data.URL) {
    contexHtml += `<a class="nsbtn btn--animated btn--border btn btn-default btn-sm btn-block edit-auth-btn " href="/url/update?ID_URL=${data.URL.ID_URL}" data-decrypted-url="/url/update?ID_URL=${data.URL.ID_URL}" data-user-link="1">Edit</a>`
  }
  return contexHtml
}

jQuery(document).on('mouseover', manageAuthSelector, function (event) {
  jQuery(this).qtip(
    {
      overwrite: false,
      content: async function () {
        const res = await jQuery.ajax({
          url: manageAuthUrl,
          type: 'GET',
          data: {
            params: { URL: jQuery(this).attr('href') },
          },
        })
        let qtipContent = qtipRender(res.BODY)
        let btn = jQuery('<div>' + qtipContent + '</div>')
        return btn
      },
      show: {
        event: event.type,
        ready: true,
      },
      hide: {
        event: 'click unfocus',
      },
      events: {
        show: function (event, api) {
          if (jQuery('body').hasClass('manage-auth') === false) {
            event.preventDefault()
          }
        },
      },
    },
    event
  )
})

export function dynamicComponentImport(component) {
  let module
  switch (component) {
    case 'List': {
      module = () => import('../../list-new/ListContainer')
      break
    }
    case 'MongoList': {
      module = () => import('../../list-new/ListContainer')
      break
    }
    case 'QueryList': {
      module = () => import('../../list-new/ListContainer')
      break
    }
    case 'TaskList': {
      module = () => import('../../list-new/ListContainer')
      break
    }
    case 'DynForm': {
      module = () => import('../../DynForm')
      break
    }
    case 'ProcessBuilder': {
      module = () => import('../../process-builder/ProcessBuilder')
      break
    }
    case 'KanbanWrapper': {
      module = () => import('../../kanban/KanbanWrapper')
      break
    }
    case 'TaskBoard': {
      module = () => import('../../task-board/TaskBoard')
      break
    }
    case 'StatusLine': {
      module = () => import('../../status-line/StatusLine')
      break
    }
    case 'Relationships': {
      module = () => import('../../relationships/Relationships')
      break
    }
    case 'FullCalendarWrapper': {
      module = () => import('../../fullcalendar/FullCalendarWrapper')
      break
    }
    case 'Clock': {
      module = () => import('../../clock/Clock')
      break
    }
    case 'API': {
      module = () => import('../../api/API')
      break
    }
    case 'Panel': {
      module = () => import('../../Panel')
      break
    }
    case 'ListView': {
      module = () => import('../../list-view/ListView')
      break
    }
    case 'QueryListView': {
      module = () => import('../../list-view/ListView')
      break
    }
    case 'ProcessListView': {
      module = () => import('../../list-view/ListView')
      break
    }
    case 'TemplateView': {
      module = () => import('../../list-view/TemplateView')
      break
    }
    case 'TemplateViewer': {
      module = () => import('../../list-view/TemplateViewer')
      break
    }
    case 'LeafletWrapper': {
      module = () => import('../../leaflet/LeafletWrapper')
      break
    }
    case 'DocumentList': {
      module = () => import('../../list/DocumentList')
      break
    }
    case 'WorkflowDesigner': {
      module = () => import('../../workflow-designer/WorkflowDesigner')
      break
    }
    case 'ListFilter': {
      module = () => import('../../list-filter/ListFilter')
      break
    }
    case 'QueryListFilter': {
      module = () => import('../../list-filter/ListFilter')
      break
    }
    case 'ProcessListFilter': {
      module = () => import('../../list-filter/ListFilter')
      break
    }
    case 'WorkflowViewer': {
      module = () => import('../../workflow-designer/WorkflowViewer')
      break
    }
    case 'ProcessButton': {
      module = () => import('../../process-builder/ProcessButton')
      break
    }
    case 'ProcessButtonList': {
      module = () => import('../../ProcessButtonList')
      break
    }
    case 'VueCircle': {
      module = () => import('vue2-circle-progress')
      break
    }
    case 'Competence': {
      module = () => import('../../Competence')
      break
    }
    case 'QueryBuilder': {
      module = () => import('../../query-builder/Schema')
      break
    }
    case 'MenuEditor': {
      module = () => import('../../menu-editor/MenuEditor')
      break
    }
    case 'ChangelogPanel': {
      module = () => import('../../changelog/ChangelogPanel')
      break
    }
    case 'JsonForm': {
      module = () => import('../../json-form-panel/JsonForm')
      break
    }
    case 'ChartJS': {
      module = () => import('../../chart/ChartJS')
      break
    }
    case 'DashboardGenerator': {
      module = () => import('../../dashboard-generator/DashboardGenerator')
      break
    }
    case 'FormDataVersion': {
      module = () => import('../../form-version/FormDataVersion')
      break
    }
    case 'LangSwicher': {
      module = () => import('../../nav-menu/LangSwitcher.vue')
      break
    }
    case 'LanguageTranslator': {
      module = () => import('../../localization/LanguageTranslator.vue')
      break
    }
    case 'Localization': {
      module = () => import('../../localization/Localization')
      break
    }
    case 'Dashboard': {
      module = () => import('../../doto-dashboard/Dashboard')
      break
    }
    case 'ProgressBar': {
      module = () => import('../../ProgressBar')
      break
    }
    case 'Carousel': {
      module = () => import('../../carousel/Carousel')
      break
    }
    case 'Gantt': {
      module = () => import('../../gantt/Gantt')
      break
    }
    case 'FormDesigner': {
      module = () => import('../../form-designer/FormDesigner')
      break
    }
    case 'FormDesignerOld': {
      module = () => import('../../form-designer/FormDesignerOld')
      break
    }
    case 'EntityConnection': {
      module = () => import('../../creator/EntityConnection')
      break
    }
    case 'GuiEditor': {
      module = () => import('../gui-editor/LayoutDesigner')
      break
    }
    case 'ConfigManager': {
      module = () => import('../../config-manager/ConfigManager')
      break
    }
    case 'EnvironmentManager': {
      module = () => import('../../config-manager/EnvironmentManager')
      break
    }
    case 'Sitemap': {
      module = () => import('../../creator/Sitemap.vue')
      break
    }
    case 'Monitoring': {
      module = () => import('../../monitoring/Monitoring.vue')
      break
    }
    case 'Checklist': {
      module = () => import('../../monitoring/Checklist.vue')
      break
    }
    case 'breadcrumb': {
      module = () => import('../../breadcrumb/Breadcrumb.vue')
      break
    }
    case 'BreadcrumbEditor': {
      module = () => import('../../breadcrumb/BreadcrumbEditor')
      break
    }
    case 'AssetManager': {
      module = () => import('../../asset-manager/AssetManager')
      break
    }
    case 'Helpy': {
      module = () => import('../../helpy/Helpy')
      break
    }
    case 'HelpyDesigner': {
      module = () => import('../../helpy-designer/HelpyDesigner')
      break
    }
    case 'HelpyForm': {
      module = () => import('../../helpy-designer/HelpyForm')
      break
    }
    case 'ProcessList': {
      module = () => import('../../process-list/ProcessList')
      break
    }
    case 'ProcessQueueList': {
      module = () => import('../../process-list/ProcessQueueList')
      break
    }
    case 'FormView': {
      module = () => import('../../form-view/FormView')
      break
    }
    case 'MenuPanel': {
      module = () => import('../../menu-panel/MenuPanel')
      break
    }
    case 'CustomComponentEditor': {
      module = () => import(`../../custom-components/CustomComponentEditor.vue`)
      break
    }
    case 'ChangePassword': {
      module = () => import(`../../custom-components/ChangePassword.vue`)
      break
    }
    case 'RawSqlEditor': {
      module = () => import(`../../raw-sql/RawSqlEditor.vue`)
      break
    }
    case 'RawSqlList': {
      module = () => import(`../../raw-sql/RawSqlListContainer.vue`)
      break
    }
    case 'EditableList': {
      module = () => import('../../list-new/ListContainer')
      break
    }
    case 'ButtonList': {
      module = () => import('../../button-list/ButtonList.vue')
      break
    }
    case 'TemplatedList': {
      module = () => import('../../templated-list/TemplatedListStore')
      break
    }
    case 'DynFormNew': {
      module = () => import('../../DynFormNew.vue')
      break
    }
    default: {
      module = () => import(`../../custom-components/CustomComponentLoader.vue`)
      break
    }
  }
  return module
}
